export default {
    "aberts-towhee": {
        "name": "Abert's towhee",
        "slug": "aberts-towhee",
        "text": "",
        "duration": "T1M26S",
        "order": 74
    },
    "acadian-flycatcher": {
        "name": "Acadian flycatcher",
        "slug": "acadian-flycatcher",
        "text": "",
        "duration": "T35S",
        "order": 153
    },
    "acorn-woodpecker": {
        "name": "Acorn woodpecker",
        "slug": "acorn-woodpecker",
        "text": "",
        "duration": "T4M35S",
        "order": 451
    },
    "alder-flycatcher": {
        "name": "Alder flycatcher",
        "slug": "alder-flycatcher",
        "text": "",
        "duration": "T1M13S",
        "order": 108
    },
    "allens-hummingbird": {
        "name": "Allen's hummingbird",
        "slug": "allens-hummingbird",
        "text": "",
        "duration": "T3M26S",
        "order": 323
    },
    "american-avocet": {
        "name": "American avocet",
        "slug": "american-avocet",
        "text": "",
        "duration": "T17S",
        "order": 268
    },
    "american-bittern": {
        "name": "American Bittern",
        "slug": "american-bittern",
        "text": "",
        "duration": "T13S",
        "order": 422
    },
    "american-black-duck": {
        "name": "American black duck",
        "slug": "american-black-duck",
        "text": "",
        "duration": "T6S",
        "order": 430
    },
    "american-coot": {
        "name": "American coot",
        "slug": "american-coot",
        "text": "",
        "duration": "T39S",
        "order": 479
    },
    "american-crow": {
        "name": "American crow",
        "slug": "american-crow",
        "text": "",
        "duration": "T24S",
        "order": 493
    },
    "american-dipper": {
        "name": "American dipper",
        "slug": "american-dipper",
        "text": "",
        "duration": "T39S",
        "order": 305
    },
    "american-golden-plover": {
        "name": "American golden plover",
        "slug": "american-golden-plover",
        "text": "",
        "duration": "T10S",
        "order": 267
    },
    "american-goldfinch": {
        "name": "American goldfinch",
        "slug": "american-goldfinch",
        "text": "",
        "duration": "T48S",
        "order": 536
    },
    "american-kestrel": {
        "name": "American kestrel",
        "slug": "american-kestrel",
        "text": "",
        "duration": "T12S",
        "order": 540
    },
    "american-oystercatcher": {
        "name": "American oystercatcher",
        "slug": "american-oystercatcher",
        "text": "",
        "duration": "T20S",
        "order": 204
    },
    "american-pipit": {
        "name": "American pipit",
        "slug": "american-pipit",
        "text": "",
        "duration": "T14S",
        "order": 216
    },
    "american-redstart": {
        "name": "American redstart",
        "slug": "american-redstart",
        "text": "",
        "duration": "T52S",
        "order": 409
    },
    "american-robin": {
        "name": "American robin",
        "slug": "american-robin",
        "text": 'The American robin (Turdus migratorius) is a medium-sized songbird with a distinctive appearance and behavior. It is found in a wide range of habitats across much of the United States and Canada, and is known for its orange-red breast, its cheerful, melodic songs, and its fondness for worms and insects. In this article, we will explore the fascinating world of the American robin, including its physical characteristics, habitat, diet, behavior, and conservation status.\n\nPhysical Characteristics of American Robins\n\nAmerican robins are medium-sized birds, with a length of about 9 to 11 inches and a wingspan of about 12 to 15 inches. They have a distinctive appearance, with a large, round head, a short, thick bill, and a long, pointed tail. They have a gray back and wings, and an orange-red breast.\n\nMale and female American robins are similar in appearance, but males have a brighter, more colorful plumage. Juvenile American robins are similar in appearance to adults, but have a more mottled, speckled plumage.\n\nAmerican robins are known for their cheerful, melodic songs, which include a variety of different whistles, chirps, and trills. They also have a variety of softer, more subdued calls, which they use to communicate with each other.\n\nHabitat and Distribution of American Robins\n\nAmerican robins are found in a wide range of habitats across much of the United States and Canada, including forests, woodlands, grasslands, and urban areas. They are found in a variety of habitats, including deciduous forests, coniferous forests, and mixed forests. They are also found in gardens, parks, and other green spaces.\n\nIn their natural habitat, American robins are found in wooded areas, where they can find food and shelter in the form of worms, insects, and other small prey. They are adapted to living in forested environments and are able to thrive in the dense canopy of these habitats. In urban areas, they are often found in gardens, parks, and other green spaces, where they can find food and shelter.\n\nDiet and Feeding Behavior of American Robins\n\nAmerican robins are omnivorous, meaning they eat both plants and animals. Their diet consists of worms, insects, berries, and other small prey. They are opportunistic feeders and will eat whatever food is available to them.\n\nAmerican robins are active during the day and are often seen foraging for food in gardens, parks, and other green spaces. They are known to feed on a variety of worms, including earthworms and grubs, as well as a variety of insects, including beetles, ants, and grasshoppers. They are also known to feed on fruit, including berries, cherries, and grapes.\n\nBehavior and Communication of American Robins\n\nAmerican robins are social birds and are often seen in pairs or small groups. They are vocal birds and have a variety of different calls and songs, which they use to communicate with each other and to defend their territory.\n\nMale American robins are known for their cheerful, melodic songs, which they use to attract mates and defend their territory. They have a variety of different songs, including a variety of different whistles, chirps, and trills. Female American robins are less vocal and tend to give shorter, softer calls.',
        "duration": "T2M20S",
        "order": 564
    },
    "american-three-toed-woodpecker": {
        "name": "American three-toed woodpecker",
        "slug": "american-three-toed-woodpecker",
        "text": "",
        "duration": "T1M54S",
        "order": 107
    },
    "american-tree-sparrow": {
        "name": "American tree sparrow",
        "slug": "american-tree-sparrow",
        "text": "",
        "duration": "T25S",
        "order": 237
    },
    "american-white-ibis": {
        "name": "American white ibis",
        "slug": "american-white-ibis",
        "text": "",
        "duration": "T7S",
        "order": 304
    },
    "american-wigeon": {
        "name": "American wigeon",
        "slug": "american-wigeon",
        "text": "",
        "duration": "T1S",
        "order": 440
    },
    "american-woodcock": {
        "name": "American woodcock",
        "slug": "american-woodcock",
        "text": "",
        "duration": "T19S",
        "order": 481
    },
    "ancient-murrelet": {
        "name": "Ancient murrelet",
        "slug": "ancient-murrelet",
        "text": "",
        "duration": "T7S",
        "order": 215
    },
    "anhinga": {
        "name": "Anhinga",
        "slug": "anhinga",
        "text": "",
        "duration": "T14S",
        "order": 525
    },
    "annas-hummingbird": {
        "name": "Anna's hummingbird",
        "slug": "annas-hummingbird",
        "text": "",
        "duration": "T1M58S",
        "order": 543
    },
    "antillean-nighthawk": {
        "name": "Antillean nighthawk",
        "slug": "antillean-nighthawk",
        "text": "",
        "duration": "T2M32S",
        "order": 13
    },
    "arctic-redpoll": {
        "name": "Arctic Redpoll",
        "slug": "arctic-redpoll",
        "text": "",
        "duration": "T14S",
        "order": 45
    },
    "arctic-tern": {
        "name": "Arctic tern",
        "slug": "arctic-tern",
        "text": 'The Arctic tern (Sterna paradisaea) is a small, migratory bird with a distinctive appearance and behavior. It is found in the Arctic regions of the Northern Hemisphere and is known for its long migrations, which take it to the southernmost regions of the world and back again each year. In this article, we will explore the fascinating world of the Arctic tern, including its physical characteristics, habitat, diet, behavior, and conservation status.\n\nPhysical Characteristics of Arctic Terns\n\nArctic terns are small birds, with a length of about 10 to 12 inches and a wingspan of about 22 to 24 inches. They have a distinctive appearance, with a thin, pointed bill, a slender body, and a long, forked tail. They have a white and grey plumage, with a pale grey head, neck, and breast, and a darker grey back and wings.\n\nMale and female Arctic terns are similar in appearance, but males have a slightly thicker bill. Juvenile Arctic terns are similar in appearance to adults, but have a brown, rather than a grey, plumage.\n\nArctic terns are known for their distinctive calls, which include a series of high-pitched "tsee-tsee" calls. They also have a variety of softer, more subdued calls, which they use to communicate with each other.\n\nHabitat and Distribution of Arctic Terns\n\nArctic terns are found in the Arctic regions of the Northern Hemisphere, including the Arctic tundra, coastal areas, and islands. They are migratory birds and travel long distances each year, spending the summer in the Arctic and the winter in the southernmost regions of the world, including Antarctica, South America, Africa, and Australia.\n\nIn their natural habitat, Arctic terns are found in a variety of habitats, including tundra, coastal areas, and islands. They are adapted to living in cold, wet environments and are able to thrive in the harsh conditions of the Arctic. They are also adaptable birds and are able to survive in a wide range of habitats, including wetlands, grasslands, and agricultural areas.\n\nDiet and Feeding Behavior of Arctic Terns\n\nArctic terns are carnivorous, meaning they eat animals. Their diet consists of small fish, crustaceans, and other marine animals. They are opportunistic feeders and will eat whatever food is available to them.\n\nArctic terns are gregarious birds and are often seen in large flocks. They are known to feed in shallow water or on land, where they use their long, pointed bills to catch prey. They are also known to feed on grains and seeds in agricultural fields, where they can cause damage to crops.\n\nBehavior and Communication of Arctic Terns\n\nArctic terns are social birds and are often seen in large flocks. They are vocal birds and have a variety of different calls and songs, which they use to communicate with each other and to defend their territory.\n\nMale Arctic terns are known for their distinctive songs, which they use to attract mates and defend their territory. They have a variety of different songs, including a series of high-pitched "tsee-tsee" calls. Female Arctic terns are less vocal and tend to give shorter, softer calls.\n\nArctic terns are territorial birds and will defend their territory from other terns and other birds. They are also known to be aggressive towards other birds at feeding stations, and will often dominate and exclude other species from feeding areas.',
        "duration": "T29S",
        "order": 572
    },
    "arizona-woodpecker": {
        "name": "Arizona woodpecker",
        "slug": "arizona-woodpecker",
        "text": "",
        "duration": "T34S",
        "order": 223
    },
    "ash-throated-flycatcher": {
        "name": "Ash-throated flycatcher",
        "slug": "ash-throated-flycatcher",
        "text": "",
        "duration": "T26S",
        "order": 78
    },
    "atlantic-puffin": {
        "name": "Atlantic puffin",
        "slug": "atlantic-puffin",
        "text": "",
        "duration": "T1M28S",
        "order": 513
    },
    "bachmans-sparrow": {
        "name": "Bachman's sparrow",
        "slug": "bachmans-sparrow",
        "text": "",
        "duration": "T1M39S",
        "order": 60
    },
    "bairds-sandpiper": {
        "name": "Baird's sandpiper",
        "slug": "bairds-sandpiper",
        "text": "",
        "duration": "T9S",
        "order": 158
    },
    "bairds-sparrow": {
        "name": "Baird's sparrow",
        "slug": "bairds-sparrow",
        "text": "",
        "duration": "T16S",
        "order": 59
    },
    "bald-eagle": {
        "name": "Bald eagle",
        "slug": "bald-eagle",
        "text": "You might know it as the national emblem of the United States or you might even have its picture as your screensaver. The Bald eagle is one of the most iconic and prominent birds in North America. If you’re ever near reservoirs, marshes, coasts, rivers, and lakes, listen for the renowned sharp screeches Bald eagles make.\n" +
            "These great creatures are also very large, weighing about 105.8-222.2 oz (3000-6300 g) and having 27.9-37.8 in (71-96 cm) in length. Although large enough on their own, Bald eagles flaunt their great stature when they start soaring in the sky. They have a wingspan of 80.3 in (204 cm) that creates a bolting shadow on the ground.\n" +
            "These birds are known for their distinctive color. They have a dark brown body and white heads and tails while their bills and feet are an eye-catching yellow. In their 20-30 years lifespan, Bald eagles look for a mate in the fourth or fifth year.\n" +
            "Their offspring are raised by monogamous parents in a lovely nest. Later on, they learn to hunt fish, birds, and small mammals like their parents and leave the nest.\n",
        "duration": "T16S",
        "order": 596
    },
    "baltimore-oriole": {
        "name": "Baltimore oriole",
        "slug": "baltimore-oriole",
        "text": "",
        "duration": "T1M1S",
        "order": 408
    },
    "band-tailed-pigeon": {
        "name": "Band-tailed pigeon",
        "slug": "band-tailed-pigeon",
        "text": "",
        "duration": "T10S",
        "order": 346
    },
    "bank-swallow": {
        "name": "Bank swallow",
        "slug": "bank-swallow",
        "text": "",
        "duration": "T51S",
        "order": 124
    },
    "bare-throated-tiger-heron": {
        "name": "Bare-throated tiger heron",
        "slug": "bare-throated-tiger-heron",
        "text": "",
        "duration": "T9S",
        "order": 52
    },
    "barn-owl": {
        "name": "Barn owl",
        "slug": "barn-owl",
        "text": "The barn owl is one of the most fascinating creatures that can be found almost everywhere except in the polar and desert regions. As they are found all over the world, there can be minor differences in size and color pattern among species of different regions.\n" +
            "All in all, these are considered small, having 12.6-15.8 in (32-40 cm) in length and weighing about 14.1-24.7 oz (400-700 g). Barn owls are generally a pale mixture of brown and white with piercing black eyes. In nature, they can be seen in dense trees slumbering in their nests on branches. When nighttime arrives, Barn owls wake up and begin their quest for prey. They soar low repeatedly over open habitats.\n" +
            "They usually feed on small rodents and recognize them by their sounds. Despite the fact that these animals reproduce many times, most of their offspring don’t witness the days of adulthood. However, if all goes well, they can live up to 18 years. As their name suggests, these birds prefer abandoned barns or similar places to build a nest and reside. So if you have a barn, it’s better to check it out. You may find an interesting nest there.",
        "duration": "T22S",
        "order": 593
    },
    "barn-swallow": {
        "name": "Barn swallow",
        "slug": "barn-swallow",
        "text": 'The barn swallow (Hirundo rustica) is a small, agile bird with a distinctive appearance and behavior. It is found in a wide range of habitats across much of the world, and is known for its graceful, aerial flight, its distinctive, deeply forked tail, and its mud-nest building habits. In this article, we will explore the fascinating world of the barn swallow, including its physical characteristics, habitat, diet, behavior, and conservation status.\n\nPhysical Characteristics of Barn Swallows\n\nBarn swallows are small birds, with a length of about 5.5 to 7 inches and a wingspan of about 7.5 to 9 inches. They have a distinctive appearance, with a small, streamlined head, a small, sharp bill, and a deeply forked tail. They have a sleek, streamlined body, with long, pointed wings and a short, rounded tail.\n\nMale and female barn swallows are similar in appearance, but males have a brighter, more colorful plumage. Juvenile barn swallows are similar in appearance to adults, but have a more mottled, speckled plumage.\n\nBarn swallows are known for their distinctive calls, which include a series of high-pitched, musical "tsip" calls. They also have a variety of softer, more subdued calls, which they use to communicate with each other.\n\nHabitat and Distribution of Barn Swallows\n\nBarn swallows are found in a wide range of habitats across much of the world, including Europe, Asia, Africa, and the Americas. They are found in a variety of habitats, including grasslands, wetlands, forests, and urban areas. They are also found in gardens, parks, and other green spaces.\n\nIn their natural habitat, barn swallows are found in open, grassy areas, where they can find food and shelter in the form of insects and other small prey. They are adaptable birds and are able to thrive in a wide range of environments. In urban areas, they are often found in gardens, parks, and other green spaces, where they can find food and shelter.\n\nDiet and Feeding Behavior of Barn Swallows\n\nBarn swallows are insectivorous, meaning they eat insects. Their diet consists of a wide variety of insects, including flies, mosquitoes, beetles, and moths. They are opportunistic feeders and will eat whatever insects are available to them.\n\nBarn swallows are highly agile birds and are known for their graceful, aerial flight. They are often seen flying low over fields, grasslands, and other open areas, using their keen eyesight and quick reflexes to catch insects in mid-air. They are also known to forage for insects on the ground, using their sharp bills to catch prey.\n\nBehavior and Communication of Barn Swallows\n\nBarn swallows are social birds and are often seen in pairs or small groups. They are vocal birds and have a variety of different calls and songs, which they use to communicate with each other and to defend their territory.\n\nMale barn swallows are known for their distinctive songs, which they use to attract mates and defend their territory. They have a variety of different songs, including a series of high-pitched, musical "tsip" calls. Female barn swallows are less vocal and tend to give shorter, softer calls.\n\nBarn swallows are territorial birds and will defend their territory from other swallows and other birds. They are also known to be aggressive towards other birds.',
        "duration": "T1M44S",
        "order": 567
    },
    "barnacle-goose": {
        "name": "Barnacle goose",
        "slug": "barnacle-goose",
        "text": "",
        "duration": "T3M46S",
        "order": 383
    },
    "barred-owl": {
        "name": "Barred owl",
        "slug": "barred-owl",
        "text": "Unlike Great horned owls, Barred owls have a gentle soothing gaze. They’re also smaller than Great horned owls, but they are larger than barn owls.\n" +
            "Barred owls have a beautiful pattern of bars and marks that are mixed with white and brown. So when they perch on a snowy tree in winter, they blend easily with their surroundings.\n" +
            "If you want to find Barred owls, you can look for them in the depths of forests, especially if they’re close to water. Tree cavities are considered houses to Barred owls. They build their nests and grow their families there. Like many other owls, Barred owls spend their day roosting. However, you can sometimes hear them during the day as well. But when the sun sets, they venture into the forest, looking for small animals. Barred owls usually prefer rodents as prey, but they may also look for frogs, snakes, lizards, salamanders, birds, and insects if they’re hungry. \n" +
            "Barred owls usually lay 2 to 3 eggs. When they hatch, owls spend most of their time with the female, while the male hunts and provides food for the family. Soon after six weeks, they learn to fly and be on their own.",
        "duration": "T15S",
        "order": 584
    },
    "barrows-goldeneye": {
        "name": "Barrow's goldeneye",
        "slug": "barrows-goldeneye",
        "text": "",
        "duration": "T1M15S",
        "order": 167
    },
    "bay-breasted-warbler": {
        "name": "Bay-breasted warbler",
        "slug": "bay-breasted-warbler",
        "text": "",
        "duration": "T47S",
        "order": 273
    },
    "bells-sparrow": {
        "name": "Bell's sparrow",
        "slug": "bells-sparrow",
        "text": "",
        "duration": "T24S",
        "order": 12
    },
    "bells-vireo": {
        "name": "Bell's vireo",
        "slug": "bells-vireo",
        "text": "",
        "duration": "T1M25S",
        "order": 146
    },
    "belted-kingfisher": {
        "name": "Belted kingfisher",
        "slug": "belted-kingfisher",
        "text": "",
        "duration": "T12S",
        "order": 530
    },
    "bendires-thrasher": {
        "name": "Bendire's thrasher",
        "slug": "bendires-thrasher",
        "text": "",
        "duration": "T51S",
        "order": 28
    },
    "bewicks-wren": {
        "name": "Bewick's wren",
        "slug": "bewicks-wren",
        "text": "",
        "duration": "T59S",
        "order": 371
    },
    "bicknells-thrush": {
        "name": "Bicknell's thrush",
        "slug": "bicknells-thrush",
        "text": "",
        "duration": "T1M59S",
        "order": 100
    },
    "black-guillemot": {
        "name": "Black guillemot",
        "slug": "black-guillemot",
        "text": "",
        "duration": "T48S",
        "order": 236
    },
    "black-oystercatcher": {
        "name": "Black oystercatcher",
        "slug": "black-oystercatcher",
        "text": "",
        "duration": "T1M0S",
        "order": 256
    },
    "black-phoebe": {
        "name": "Black phoebe",
        "slug": "black-phoebe",
        "text": "",
        "duration": "T18S",
        "order": 415
    },
    "black-rail": {
        "name": "Black rail",
        "slug": "black-rail",
        "text": "",
        "duration": "T39S",
        "order": 363
    },
    "black-rosy-finch": {
        "name": "Black rosy finch",
        "slug": "black-rosy-finch",
        "text": "",
        "duration": "T15S",
        "order": 27
    },
    "black-scoter": {
        "name": "Black scoter",
        "slug": "black-scoter",
        "text": "",
        "duration": "T1M3S",
        "order": 266
    },
    "black-skimmer": {
        "name": "Black skimmer",
        "slug": "black-skimmer",
        "text": "",
        "duration": "T1M36S",
        "order": 362
    },
    "black-swift": {
        "name": "Black swift",
        "slug": "black-swift",
        "text": "",
        "duration": "T13S",
        "order": 272
    },
    "black-tern": {
        "name": "Black tern",
        "slug": "black-tern",
        "text": "",
        "duration": "T35S",
        "order": 214
    },
    "black-turnstone": {
        "name": "Black turnstone",
        "slug": "black-turnstone",
        "text": "",
        "duration": "T56S",
        "order": 112
    },
    "black-and-white-warbler": {
        "name": "Black-and-white warbler",
        "slug": "black-and-white-warbler",
        "text": "",
        "duration": "T1M7S",
        "order": 399
    },
    "black-backed-woodpecker": {
        "name": "Black-backed woodpecker",
        "slug": "black-backed-woodpecker",
        "text": "",
        "duration": "T16S",
        "order": 235
    },
    "black-bellied-whistling-duck": {
        "name": "Black-bellied whistling duck",
        "slug": "black-bellied-whistling-duck",
        "text": "",
        "duration": "T3M0S",
        "order": 454
    },
    "black-billed-cuckoo": {
        "name": "Black-billed cuckoo",
        "slug": "black-billed-cuckoo",
        "text": "",
        "duration": "T38S",
        "order": 166
    },
    "black-billed-magpie": {
        "name": "Black-billed magpie",
        "slug": "black-billed-magpie",
        "text": "",
        "duration": "T37S",
        "order": 475
    },
    "black-browed-albatross": {
        "name": "Black-browed albatross",
        "slug": "black-browed-albatross",
        "text": "",
        "duration": "T20S",
        "order": 271
    },
    "blackburnian-warbler": {
        "name": "Blackburnian warbler",
        "slug": "blackburnian-warbler",
        "text": "",
        "duration": "T1M38S",
        "order": 335
    },
    "black-capped-chickadee": {
        "name": "Black-capped chickadee",
        "slug": "black-capped-chickadee",
        "text": "",
        "duration": "T21S",
        "order": 553
    },
    "black-capped-vireo": {
        "name": "Black-capped vireo",
        "slug": "black-capped-vireo",
        "text": "",
        "duration": "T3S",
        "order": 83
    },
    "black-chinned-hummingbird": {
        "name": "Black-chinned hummingbird",
        "slug": "black-chinned-hummingbird",
        "text": "",
        "duration": "T3M31S",
        "order": 453
    },
    "black-chinned-sparrow": {
        "name": "Black-chinned sparrow",
        "slug": "black-chinned-sparrow",
        "text": "",
        "duration": "T58S",
        "order": 22
    },
    "black-crested-titmouse": {
        "name": "Black-crested titmouse",
        "slug": "black-crested-titmouse",
        "text": "",
        "duration": "T59S",
        "order": 176
    },
    "black-crowned-night-heron": {
        "name": "Black-crowned night heron",
        "slug": "black-crowned-night-heron",
        "text": "",
        "duration": "T1M35S",
        "order": 505
    },
    "black-footed-albatross": {
        "name": "Black-footed albatross",
        "slug": "black-footed-albatross",
        "text": "",
        "duration": "T18S",
        "order": 165
    },
    "black-headed-grosbeak": {
        "name": "Black-headed grosbeak",
        "slug": "black-headed-grosbeak",
        "text": "",
        "duration": "T26S",
        "order": 303
    },
    "black-legged-kittiwake": {
        "name": "Black-legged kittiwake",
        "slug": "black-legged-kittiwake",
        "text": "",
        "duration": "T27S",
        "order": 222
    },
    "black-necked-grebe": {
        "name": "Black-necked Grebe",
        "slug": "black-necked-grebe",
        "text": "",
        "duration": "T2M59S",
        "order": 137
    },
    "black-necked-stilt": {
        "name": "Black-necked stilt",
        "slug": "black-necked-stilt",
        "text": "",
        "duration": "T1M38S",
        "order": 286
    },
    "blackpoll-warbler": {
        "name": "Blackpoll warbler",
        "slug": "blackpoll-warbler",
        "text": "",
        "duration": "T1M4S",
        "order": 356
    },
    "black-tailed-gnatcatcher": {
        "name": "Black-tailed gnatcatcher",
        "slug": "black-tailed-gnatcatcher",
        "text": "",
        "duration": "T19S",
        "order": 30
    },
    "black-throated-blue-warbler": {
        "name": "Black-throated blue warbler",
        "slug": "black-throated-blue-warbler",
        "text": "",
        "duration": "T28S",
        "order": 345
    },
    "black-throated-gray-warbler": {
        "name": "Black-throated gray warbler",
        "slug": "black-throated-gray-warbler",
        "text": "",
        "duration": "T32S",
        "order": 123
    },
    "black-throated-green-warbler": {
        "name": "Black-throated green warbler",
        "slug": "black-throated-green-warbler",
        "text": "",
        "duration": "T26S",
        "order": 293
    },
    "black-throated-sparrow": {
        "name": "Black-throated sparrow",
        "slug": "black-throated-sparrow",
        "text": "",
        "duration": "T1M10S",
        "order": 122
    },
    "black-whiskered-vireo": {
        "name": "Black-whiskered vireo",
        "slug": "black-whiskered-vireo",
        "text": "",
        "duration": "T32S",
        "order": 32
    },
    "blue-grosbeak": {
        "name": "Blue grosbeak",
        "slug": "blue-grosbeak",
        "text": "",
        "duration": "T15S",
        "order": 302
    },
    "blue-jay": {
        "name": "Blue jay",
        "slug": "blue-jay",
        "text": "The blue jay is considered native to eastern North America as a passerine bird. You can find this bird in most eastern and central United States. Cyanocitta cristata is the scientific name of Blue Jay and it is among the family Corvidae. Most Blue Jays live for 7 years, but exceptions were found to live up to 26 years and 3 months. While their bodies appear tiny, their wingspan is 13-17 inches and they weigh 2.5-3.5 oz (70-100 g) on average.\n" +
            "Although they’re prone to a vegetarian diet, they’re considered omnivorous. They love any kind of seeds and grains such as nuts, corn, and peanuts. In mid-March, their mating season begins and continues into July. A typical Blue Jay monogamously pairs with a partner for life and they build a nest together. When it comes to migration, Blue Jays are ambiguous. The young ones tend to migrate more often. Some move to the south for a year and then migrate north the next and so on.\n" +
            "Blue Jays are distinguishable by their unique sounds and they may even learn to mimic human speech. Unlike their adorable looks, Jays are aggressive and territorial. They may attack and drive any bird away from potential bird feeders.\n",
        "duration": "T3M34S",
        "order": 602
    },
    "blue-footed-booby": {
        "name": "Blue-footed booby",
        "slug": "blue-footed-booby",
        "text": "With their eccentric appearance and peculiar name, Blue-footed boobies may seem like a character from an animated movie, but they are very much real. These birds have brown wings with a white body. But their most noticeable feature is their blue feet.\n" +
            "Numerous islands in the tropical eastern Pacific are home to many Blue-footed boobies. Though they can be found in the United States and Canada, it’s best to look for them around the Gulf of Mexico.\n" +
            "Watching these birds look for fish is a meditating and serene experience. They follow the fish in the water in great flocks and make a smooth glorious dive when they’re ready.\n" +
            "Boobies are not particularly large. They are about 32 to 34 inches and weigh around 3.25 pounds. Their blue feet are not only intriguing to us. Bluer feet among boobies mean more chance of finding a mate. When it comes to nesting, boobies' offspring don’t have an enjoyable experience. \n" +
            "Boobies avoid making any nest and they lay their eggs on the ground. However, to protect the eggs, boobies defecate on them and make a circular wall around them.\n" +
            "Boobies are tame and friendly around people and pleasant to interact with.",
        "duration": "T5M6S",
        "order": 583
    },
    "blue-gray-gnatcatcher": {
        "name": "Blue-gray gnatcatcher",
        "slug": "blue-gray-gnatcatcher",
        "text": "",
        "duration": "T42S",
        "order": 285
    },
    "blue-headed-vireo": {
        "name": "Blue-headed vireo",
        "slug": "blue-headed-vireo",
        "text": "",
        "duration": "T40S",
        "order": 284
    },
    "blue-throated-hummingbird": {
        "name": "Blue-throated hummingbird",
        "slug": "blue-throated-hummingbird",
        "text": "",
        "duration": "T55S",
        "order": 54
    },
    "blue-winged-teal": {
        "name": "Blue-winged teal",
        "slug": "blue-winged-teal",
        "text": "",
        "duration": "T16S",
        "order": 527
    },
    "blue-winged-warbler": {
        "name": "Blue-winged warbler",
        "slug": "blue-winged-warbler",
        "text": "",
        "duration": "T1M38S",
        "order": 145
    },
    "boat-tailed-grackle": {
        "name": "Boat-tailed grackle",
        "slug": "boat-tailed-grackle",
        "text": "",
        "duration": "T19S",
        "order": 316
    },
    "bobolink": {
        "name": "Bobolink",
        "slug": "bobolink",
        "text": "",
        "duration": "T51S",
        "order": 504
    },
    "bohemian-waxwing": {
        "name": "Bohemian waxwing",
        "slug": "bohemian-waxwing",
        "text": "",
        "duration": "T35S",
        "order": 449
    },
    "bonapartes-gull": {
        "name": "Bonaparte's gull",
        "slug": "bonapartes-gull",
        "text": "",
        "duration": "T24S",
        "order": 334
    },
    "bonin-petrel": {
        "name": "Bonin petrel",
        "slug": "bonin-petrel",
        "text": "",
        "duration": "T2M33S",
        "order": 4
    },
    "boreal-chickadee": {
        "name": "Boreal chickadee",
        "slug": "boreal-chickadee",
        "text": "",
        "duration": "T27S",
        "order": 221
    },
    "boreal-owl": {
        "name": "Boreal owl",
        "slug": "boreal-owl",
        "text": "",
        "duration": "T13S",
        "order": 382
    },
    "brant": {
        "name": "Brant",
        "slug": "brant",
        "text": "",
        "duration": "T30S",
        "order": 535
    },
    "brewers-blackbird": {
        "name": "Brewer's blackbird",
        "slug": "brewers-blackbird",
        "text": "",
        "duration": "T2M29S",
        "order": 315
    },
    "brewers-sparrow": {
        "name": "Brewer's sparrow",
        "slug": "brewers-sparrow",
        "text": "",
        "duration": "T1M44S",
        "order": 43
    },
    "bridled-titmouse": {
        "name": "Bridled titmouse",
        "slug": "bridled-titmouse",
        "text": "",
        "duration": "T26S",
        "order": 42
    },
    "broad-billed-hummingbird": {
        "name": "Broad-billed hummingbird",
        "slug": "broad-billed-hummingbird",
        "text": "",
        "duration": "T27S",
        "order": 203
    },
    "broad-tailed-hummingbird": {
        "name": "Broad-tailed hummingbird",
        "slug": "broad-tailed-hummingbird",
        "text": "",
        "duration": "T48S",
        "order": 270
    },
    "broad-winged-hawk": {
        "name": "Broad-winged hawk",
        "slug": "broad-winged-hawk",
        "text": "",
        "duration": "T36S",
        "order": 512
    },
    "bronzed-cowbird": {
        "name": "Bronzed cowbird",
        "slug": "bronzed-cowbird",
        "text": "",
        "duration": "T41S",
        "order": 73
    },
    "brown-booby": {
        "name": "Brown booby",
        "slug": "brown-booby",
        "text": "",
        "duration": "T37S",
        "order": 333
    },
    "brown-creeper": {
        "name": "Brown creeper",
        "slug": "brown-creeper",
        "text": "",
        "duration": "T2M13S",
        "order": 421
    },
    "brown-noddy": {
        "name": "Brown noddy",
        "slug": "brown-noddy",
        "text": "",
        "duration": "T57S",
        "order": 152
    },
    "brown-thrasher": {
        "name": "Brown thrasher",
        "slug": "brown-thrasher",
        "text": "",
        "duration": "T1M31S",
        "order": 485
    },
    "brown-crested-flycatcher": {
        "name": "Brown-crested flycatcher",
        "slug": "brown-crested-flycatcher",
        "text": "",
        "duration": "T1M9S",
        "order": 41
    },
    "brown-headed-cowbird": {
        "name": "Brown-headed cowbird",
        "slug": "brown-headed-cowbird",
        "text": "",
        "duration": "T1M10S",
        "order": 403
    },
    "brown-headed-nuthatch": {
        "name": "Brown-headed nuthatch",
        "slug": "brown-headed-nuthatch",
        "text": "",
        "duration": "T45S",
        "order": 234
    },
    "buff-bellied-hummingbird": {
        "name": "Buff-bellied hummingbird",
        "slug": "buff-bellied-hummingbird",
        "text": "",
        "duration": "T28S",
        "order": 84
    },
    "bufflehead": {
        "name": "Bufflehead",
        "slug": "bufflehead",
        "text": "",
        "duration": "T11S",
        "order": 528
    },
    "bullocks-oriole": {
        "name": "Bullock's oriole",
        "slug": "bullocks-oriole",
        "text": "",
        "duration": "T1M0S",
        "order": 202
    },
    "burrowing-owl": {
        "name": "Burrowing owl",
        "slug": "burrowing-owl",
        "text": 'The burrowing owl (Athene cunicularia) is a small, ground-dwelling bird with a distinctive appearance and behavior. It is found in the grasslands, deserts, and other open habitats of North and South America, and is known for its habit of living in burrows or other underground cavities. In this article, we will explore the fascinating world of the burrowing owl, including its physical characteristics, habitat, diet, behavior, and conservation status.\n\nPhysical Characteristics of Burrowing Owls\n\nBurrowing owls are small birds, with a length of about 7 to 10 inches and a wingspan of about 21 to 24 inches. They have a distinctive appearance, with a small, round head, a short, rounded tail, and long, thin legs. They have a pale brown and white plumage, with a white breast and a pale brown back and wings.\n\nMale and female burrowing owls are similar in appearance, but males are slightly larger. Juvenile burrowing owls are similar in appearance to adults, but have a more mottled, speckled plumage.\n\nBurrowing owls are known for their distinctive calls, which include a series of soft, mellow "hoo-hoo" calls. They also have a variety of softer, more subdued calls, which they use to communicate with each other.\n\nHabitat and Distribution of Burrowing Owls\n\nBurrowing owls are found in the grasslands, deserts, and other open habitats of North and South America. They are found in a variety of habitats, including grasslands, deserts, prairies, and agricultural areas. They are also found in gardens, parks, and other urban areas.\n\nIn their natural habitat, burrowing owls are often found in open, grassy areas, where they can find food and shelter in the form of burrows or other underground cavities. They are adaptable birds and are able to thrive in a wide range of environments. In urban areas, they are often found in gardens, parks, and other green spaces, where they can find food and shelter.\n\nDiet and Feeding Behavior of Burrowing Owls\n\nBurrowing owls are carnivorous, meaning they eat animals. Their diet consists of insects, rodents, and other small prey. They are opportunistic feeders and will eat whatever food is available to them.\n\nBurrowing owls are active during the day and at night, and will hunt for food at any time. They are known to hunt on the ground, using their long, thin legs and sharp talons to catch prey. They are also known to hunt from the air, using their keen eyesight to locate prey.\n\nBehavior and Communication of Burrowing Owls\n\nBurrowing owls are social birds and are often seen in pairs or small groups. They are vocal birds and have a variety of different calls and songs, which they use to communicate with each other and to defend their territory.\n\nMale burrowing owls are known for their distinctive songs, which they use to attract mates and defend their territory. They have a variety of different songs, including a series of soft, mellow "hoo-hoo" calls. Female burrowing owls are less vocal and tend to give shorter, softer calls.\n\nBurrowing owls are territorial birds and will defend their territory from other owls and other birds. They are also known to be aggressive towards other birds at feeding stations, and will often dominate and exclude other species from feeding areas.',
        "duration": "T18S",
        "order": 571
    },
    "bushtit": {
        "name": "Bushtit",
        "slug": "bushtit",
        "text": "",
        "duration": "T1M9S",
        "order": 429
    },
    "cackling-goose": {
        "name": "Cackling goose",
        "slug": "cackling-goose",
        "text": "",
        "duration": "T4M37S",
        "order": 355
    },
    "cactus-wren": {
        "name": "Cactus wren",
        "slug": "cactus-wren",
        "text": "",
        "duration": "T59S",
        "order": 458
    },
    "california-gnatcatcher": {
        "name": "California gnatcatcher",
        "slug": "california-gnatcatcher",
        "text": "",
        "duration": "T41S",
        "order": 89
    },
    "california-gull": {
        "name": "California gull",
        "slug": "california-gull",
        "text": "",
        "duration": "T29S",
        "order": 255
    },
    "california-quail": {
        "name": "California quail",
        "slug": "california-quail",
        "text": "",
        "duration": "T20S",
        "order": 511
    },
    "california-scrub-jay": {
        "name": "California scrub jay",
        "slug": "california-scrub-jay",
        "text": "",
        "duration": "T19S",
        "order": 432
    },
    "california-thrasher": {
        "name": "California thrasher",
        "slug": "california-thrasher",
        "text": "",
        "duration": "T1M26S",
        "order": 164
    },
    "california-towhee": {
        "name": "California towhee",
        "slug": "california-towhee",
        "text": "",
        "duration": "T1M35S",
        "order": 283
    },
    "calliope-hummingbird": {
        "name": "Calliope hummingbird",
        "slug": "calliope-hummingbird",
        "text": "",
        "duration": "T26S",
        "order": 344
    },
    "canada-goose": {
        "name": "Canada goose",
        "slug": "canada-goose",
        "text": "If you’re looking at a bird with a long neck, broad bill, large body, and webbed feet and don’t know what it is, you might be looking at a Canada goose. These animals usually have black necks and heads, while their back is brown and their breast is tan.\n" +
            "A typical Canadian goose is 29.9-43.3 in (76-110 cm) and 105.8-317.5 oz (3000-9000 g) respectively in length and weight. They live for 10-24 years and you’ll find them making natural sceneries more beautiful. As their name suggests, Canadian geese are native to Canada, but you can find them in the northern United States as well.\n" +
            "These birds are hardly found alone. They usually fly in pairs or their flocks form a V shape while flying. You might find some insects and fish occasionally in a goose’s diet, but they mostly graze the fields and dabble the waters to find some grains or greens to eat.\n" +
            "Canada geese spend the second year of their lives finding a partner whom they will spend the rest of their lives with. The female lays 5 eggs on average and they both protect the nest to let the life cycle continue.\n",
        "duration": "T34S",
        "order": 601
    },
    "canada-warbler": {
        "name": "Canada warbler",
        "slug": "canada-warbler",
        "text": "",
        "duration": "T32S",
        "order": 292
    },
    "canvasback": {
        "name": "Canvasback",
        "slug": "canvasback",
        "text": "",
        "duration": "T1M0S",
        "order": 487
    },
    "canyon-towhee": {
        "name": "Canyon towhee",
        "slug": "canyon-towhee",
        "text": "",
        "duration": "T36S",
        "order": 58
    },
    "canyon-wren": {
        "name": "Canyon wren",
        "slug": "canyon-wren",
        "text": "",
        "duration": "T1M17S",
        "order": 121
    },
    "cape-may-warbler": {
        "name": "Cape May warbler",
        "slug": "cape-may-warbler",
        "text": "",
        "duration": "T27S",
        "order": 343
    },
    "carolina-chickadee": {
        "name": "Carolina chickadee",
        "slug": "carolina-chickadee",
        "text": "",
        "duration": "T22S",
        "order": 428
    },
    "carolina-wren": {
        "name": "Carolina wren",
        "slug": "carolina-wren",
        "text": "",
        "duration": "T37S",
        "order": 546
    },
    "caspian-tern": {
        "name": "Caspian tern",
        "slug": "caspian-tern",
        "text": "",
        "duration": "T14S",
        "order": 332
    },
    "cassins-finch": {
        "name": "Cassin's finch",
        "slug": "cassins-finch",
        "text": "",
        "duration": "T59S",
        "order": 151
    },
    "cassins-kingbird": {
        "name": "Cassin's kingbird",
        "slug": "cassins-kingbird",
        "text": "",
        "duration": "T14S",
        "order": 77
    },
    "cassins-sparrow": {
        "name": "Cassin's sparrow",
        "slug": "cassins-sparrow",
        "text": "",
        "duration": "T1M14S",
        "order": 21
    },
    "cassins-vireo": {
        "name": "Cassin's vireo",
        "slug": "cassins-vireo",
        "text": "",
        "duration": "T38S",
        "order": 66
    },
    "cattle-egret": {
        "name": "Cattle egret",
        "slug": "cattle-egret",
        "text": "",
        "duration": "T10S",
        "order": 539
    },
    "cave-swallow": {
        "name": "Cave swallow",
        "slug": "cave-swallow",
        "text": "",
        "duration": "T25S",
        "order": 65
    },
    "cedar-waxwing": {
        "name": "Cedar waxwing",
        "slug": "cedar-waxwing",
        "text": 'The cedar waxwing (Bombycilla cedrorum) is a small, colorful bird with a distinctive appearance and behavior. It is found in a wide range of habitats across much of the United States and parts of Canada, and is known for its striking plumage, its fondness for fruit, and its distinctive calls. In this article, we will explore the fascinating world of the cedar waxwing, including its physical characteristics, habitat, diet, behavior, and conservation status.\n\nPhysical Characteristics of Cedar Waxwings\n\nCedar waxwings are small birds, with a length of about 6 to 7 inches and a wingspan of about 9 to 11 inches. They have a distinctive appearance, with a small, round head, a short, thin bill, and a long, pointed tail. They have a striking plumage, with a gray head and breast, a brown back and wings, and a yellow belly. They are also known for their distinctive red wax-like tips on their wings, which give them their name.\n\nMale and female cedar waxwings are similar in appearance, but males have a brighter, more colorful plumage. Juvenile cedar waxwings are similar in appearance to adults, but have a more muted, brownish plumage.\n\nCedar waxwings are known for their distinctive calls, which include a series of soft, warbling "cheee" and "cheee" sounds. They also have a variety of softer, more subdued calls, which they use to communicate with each other.\n\nHabitat and Distribution of Cedar Waxwings\n\nCedar waxwings are found in a wide range of habitats across much of the United States and parts of Canada, including forests, woodlands, grasslands, and urban areas. They are found in a variety of habitats, including deciduous forests, coniferous forests, and mixed forests. They are also found in gardens, parks, and other green spaces.\n\nIn their natural habitat, cedar waxwings are found in wooded areas, where they can find food and shelter in the form of fruit and insects. They are adapted to living in forested environments and are able to thrive in the dense canopy of these habitats. In urban areas, they are often found in gardens, parks, and other green spaces, where they can find food and shelter.\n\nDiet and Feeding Behavior of Cedar Waxwings\n\nCedar waxwings are omnivorous, meaning they eat both plants and animals. Their diet consists of fruit, insects, and other small prey. They are opportunistic feeders and will eat whatever food is available to them.\n\nCedar waxwings are active during the day and are often seen foraging for food in trees, bushes, and other wooded areas. They are known to feed on a variety of fruit, including berries, cherries, and grapes. They are also known to feed on insects, including beetles, ants, and grasshoppers.\n\nBehavior and Communication of Cedar Waxwings\n\nCedar waxwings are social birds and are often seen in pairs or small groups. They are vocal birds and have a variety of different calls and songs, which they use to communicate with each other and to defend their territory.\n\nMale cedar waxwings are known for their distinctive calls, which they use to attract mates and defend their territory.',
        "duration": "T1M41S",
        "order": 559
    },
    "cerulean-warbler": {
        "name": "Cerulean warbler",
        "slug": "cerulean-warbler",
        "text": "",
        "duration": "T30S",
        "order": 291
    },
    "chestnut-backed-chickadee": {
        "name": "Chestnut-backed chickadee",
        "slug": "chestnut-backed-chickadee",
        "text": "",
        "duration": "T22S",
        "order": 233
    },
    "chestnut-collared-longspur": {
        "name": "Chestnut-collared longspur",
        "slug": "chestnut-collared-longspur",
        "text": "",
        "duration": "T2M52S",
        "order": 51
    },
    "chestnut-sided-warbler": {
        "name": "Chestnut-sided warbler",
        "slug": "chestnut-sided-warbler",
        "text": "",
        "duration": "T53S",
        "order": 190
    },
    "chihuahuan-raven": {
        "name": "Chihuahuan raven",
        "slug": "chihuahuan-raven",
        "text": "",
        "duration": "T13S",
        "order": 136
    },
    "chimney-swift": {
        "name": "Chimney swift",
        "slug": "chimney-swift",
        "text": "",
        "duration": "T17S",
        "order": 484
    },
    "chipping-sparrow": {
        "name": "Chipping sparrow",
        "slug": "chipping-sparrow",
        "text": "",
        "duration": "T2M19S",
        "order": 437
    },
    "chuck-wills-widow": {
        "name": "Chuck-will's-widow",
        "slug": "chuck-wills-widow",
        "text": "",
        "duration": "T32S",
        "order": 301
    },
    "chukar": {
        "name": "Chukar",
        "slug": "chukar",
        "text": "",
        "duration": "T1M24S",
        "order": 548
    },
    "cinnamon-teal": {
        "name": "Cinnamon teal",
        "slug": "cinnamon-teal",
        "text": "",
        "duration": "T20S",
        "order": 474
    },
    "clapper-rail": {
        "name": "Clapper rail",
        "slug": "clapper-rail",
        "text": "",
        "duration": "T34S",
        "order": 300
    },
    "clarks-grebe": {
        "name": "Clark's grebe",
        "slug": "clarks-grebe",
        "text": "",
        "duration": "T4M30S",
        "order": 97
    },
    "clarks-nutcracker": {
        "name": "Clark's nutcracker",
        "slug": "clarks-nutcracker",
        "text": "",
        "duration": "T1M11S",
        "order": 381
    },
    "clay-colored-sparrow": {
        "name": "Clay-colored sparrow",
        "slug": "clay-colored-sparrow",
        "text": "",
        "duration": "T35S",
        "order": 227
    },
    "cliff-swallow": {
        "name": "Cliff swallow",
        "slug": "cliff-swallow",
        "text": "",
        "duration": "T1M12S",
        "order": 319
    },
    "common-black-hawk": {
        "name": "Common black hawk",
        "slug": "common-black-hawk",
        "text": "",
        "duration": "T31S",
        "order": 213
    },
    "common-eider": {
        "name": "Common eider",
        "slug": "common-eider",
        "text": "",
        "duration": "T1M23S",
        "order": 322
    },
    "common-gallinule": {
        "name": "Common gallinule",
        "slug": "common-gallinule",
        "text": "",
        "duration": "T12S",
        "order": 254
    },
    "common-goldeneye": {
        "name": "Common goldeneye",
        "slug": "common-goldeneye",
        "text": "",
        "duration": "T1M24S",
        "order": 340
    },
    "common-grackle": {
        "name": "Common grackle",
        "slug": "common-grackle",
        "text": "",
        "duration": "T1M11S",
        "order": 464
    },
    "common-ground-dove": {
        "name": "Common ground dove",
        "slug": "common-ground-dove",
        "text": "",
        "duration": "T19S",
        "order": 299
    },
    "common-loon": {
        "name": "Common loon",
        "slug": "common-loon",
        "text": "",
        "duration": "T19S",
        "order": 480
    },
    "common-merganser": {
        "name": "Common merganser",
        "slug": "common-merganser",
        "text": "",
        "duration": "T1M30S",
        "order": 473
    },
    "common-murre": {
        "name": "Common murre",
        "slug": "common-murre",
        "text": "",
        "duration": "T52S",
        "order": 331
    },
    "common-nighthawk": {
        "name": "Common nighthawk",
        "slug": "common-nighthawk",
        "text": "",
        "duration": "T30S",
        "order": 398
    },
    "common-pauraque": {
        "name": "Common pauraque",
        "slug": "common-pauraque",
        "text": "",
        "duration": "T16S",
        "order": 40
    },
    "common-peafowl": {
        "name": "Common peafowl",
        "slug": "common-peafowl",
        "text": "",
        "duration": "T16S",
        "order": 11
    },
    "common-poorwill": {
        "name": "Common poorwill",
        "slug": "common-poorwill",
        "text": "",
        "duration": "T1M0S",
        "order": 370
    },
    "common-raven": {
        "name": "Common raven",
        "slug": "common-raven",
        "text": "",
        "duration": "T17S",
        "order": 547
    },
    "common-redpoll": {
        "name": "Common redpoll",
        "slug": "common-redpoll",
        "text": "",
        "duration": "T15S",
        "order": 265
    },
    "common-ringed-plover": {
        "name": "Common ringed plover",
        "slug": "common-ringed-plover",
        "text": "",
        "duration": "T8S",
        "order": 144
    },
    "common-starling": {
        "name": "Common Starling",
        "slug": "common-starling",
        "text": "",
        "duration": "T3M46S",
        "order": 522
    },
    "common-tern": {
        "name": "Common tern",
        "slug": "common-tern",
        "text": "",
        "duration": "T20S",
        "order": 392
    },
    "common-yellowthroat": {
        "name": "Common yellowthroat",
        "slug": "common-yellowthroat",
        "text": "",
        "duration": "T24S",
        "order": 402
    },
    "connecticut-warbler": {
        "name": "Connecticut warbler",
        "slug": "connecticut-warbler",
        "text": "",
        "duration": "T27S",
        "order": 201
    },
    "coopers-hawk": {
        "name": "Cooper's hawk",
        "slug": "coopers-hawk",
        "text": "If you like watching majestic creatures soar through the sky, Cooper’s hawk is an excellent choice for you. With a classic accipiter shape, Cooper’s hawk is often seen spreading its broad round wings across the deep forests of North America. You can also find them in any place with an abundance of leaves or even in backyards. Similar to its peers, Cooper’s hawk flies in a flap-flap-glide pattern, which only adds to its impressive appearance. Plunging to the ground and up again over an obstacle to surprise their food, they usually attack their prey like an epic movie. Perched on a tree, their bodies glow like dying coal leaving their marks, and it's blanketed by blue-gray feathers reaching to their sharp head like a hunter’s cloak.\n" +
            "The male Cooper’s hawk usually has a length of 14.6-15.3 in (37-39 cm) and a weight of 7.8-14.5 oz (220-410 g), while the female appears larger with a length of 16.5-17.7 in (42-45 cm) and weight of 11.6-24.0 oz (330-680 g). However, once they start flying they’ll leave in awe as their wings are twice the size of their body or even more!",
        "duration": "T16S",
        "order": 598
    },
    "cordilleran-flycatcher": {
        "name": "Cordilleran flycatcher",
        "slug": "cordilleran-flycatcher",
        "text": "",
        "duration": "T47S",
        "order": 16
    },
    "costas-hummingbird": {
        "name": "Costa's hummingbird",
        "slug": "costas-hummingbird",
        "text": "",
        "duration": "T55S",
        "order": 339
    },
    "couchs-kingbird": {
        "name": "Couch's kingbird",
        "slug": "couchs-kingbird",
        "text": "",
        "duration": "T52S",
        "order": 50
    },
    "crissal-thrasher": {
        "name": "Crissal thrasher",
        "slug": "crissal-thrasher",
        "text": "",
        "duration": "T43S",
        "order": 34
    },
    "curve-billed-thrasher": {
        "name": "Curve-billed thrasher",
        "slug": "curve-billed-thrasher",
        "text": "",
        "duration": "T55S",
        "order": 212
    },
    "dark-eyed-junco": {
        "name": "Dark-eyed junco",
        "slug": "dark-eyed-junco",
        "text": "",
        "duration": "T1M26S",
        "order": 533
    },
    "dickcissel": {
        "name": "Dickcissel",
        "slug": "dickcissel",
        "text": "",
        "duration": "T1M7S",
        "order": 310
    },
    "double-crested-cormorant": {
        "name": "Double-crested cormorant",
        "slug": "double-crested-cormorant",
        "text": "",
        "duration": "T2M1S",
        "order": 503
    },
    "dovekie": {
        "name": "Dovekie",
        "slug": "dovekie",
        "text": "",
        "duration": "T1M6S",
        "order": 211
    },
    "downy-woodpecker": {
        "name": "Downy woodpecker",
        "slug": "downy-woodpecker",
        "text": 'The downy woodpecker (Dryobates pubescens) is a small, colorful bird with a distinctive appearance and behavior. It is found across much of North America and is a familiar sight in gardens, parks, and wooded areas. In this article, we will explore the fascinating world of the downy woodpecker, including its physical characteristics, habitat, diet, behavior, and conservation status.\n\nPhysical Characteristics of Downy Woodpeckers\n\nDowny woodpeckers are small birds, with a length of about 6 to 7 inches and a wingspan of about 9 to 11 inches. They have a distinctive appearance, with a small, conical bill, a rounded head, and a short, squared-off tail. They have a black, white, and red plumage, with a white breast and a black back.\n\nMale and female downy woodpeckers are similar in appearance, but males have a red patch on the back of their heads. Juvenile downy woodpeckers are similar in appearance to adults, but have a brown, rather than a red, patch on the back of their heads.\n\nDowny woodpeckers are known for their distinctive calls, which include a series of soft, high-pitched "pik" calls. They also have a variety of softer, more subdued calls, which they use to communicate with each other.\n\nHabitat and Distribution of Downy Woodpeckers\n\nDowny woodpeckers are found across much of North America, from southern Canada to Mexico. They are most commonly found in wooded areas, including deciduous forests, coniferous forests, and mixed forests. They are also found in gardens, parks, and other urban areas.\n\nIn their natural habitat, downy woodpeckers are often found in wooded areas, where they can find food and shelter. They are adaptable birds and are able to thrive in a wide range of environments. In urban areas, they are often found in gardens, parks, and other green spaces, where they can find food and shelter.\n\nDiet and Feeding Behavior of Downy Woodpeckers\n\nDowny woodpeckers are omnivorous, meaning they eat both plants and animals. Their diet consists of insects, fruit, seeds, and occasionally small invertebrates. They are opportunistic feeders and will eat whatever food is available to them.\n\nDowny woodpeckers are known for their distinctive feeding behavior, which involves drumming on hard surfaces with their beaks to locate insects. They will also feed on insects that they find on the ground, as well as seeds and fruit that they find in trees and bushes.\n\nBehavior and Communication of Downy Woodpeckers\n\nDowny woodpeckers are social birds and are often seen in pairs or small groups. They are vocal birds and have a variety of different calls and songs, which they use to communicate with each other and to defend their territory.\n\nMale downy woodpeckers are known for their distinctive songs, which they use to attract mates and defend their territory. They have a variety of different songs, including a series of soft, high-pitched "pik" calls. Female downy woodpeckers are less vocal and tend to give shorter, softer calls.\n\nDowny woodpeckers are territorial birds and will defend their territory from other woodpeckers and other birds. They are also known to be aggressive towards other birds at feeding stations, and will often dominate and exclude other species from feeding areas.',
        "duration": "T31S",
        "order": 575
    },
    "dunlin": {
        "name": "Dunlin",
        "slug": "dunlin",
        "text": "",
        "duration": "T6S",
        "order": 499
    },
    "dusky-flycatcher": {
        "name": "Dusky flycatcher",
        "slug": "dusky-flycatcher",
        "text": "",
        "duration": "T1M42S",
        "order": 48
    },
    "dusky-grouse": {
        "name": "Dusky grouse",
        "slug": "dusky-grouse",
        "text": "",
        "duration": "T46S",
        "order": 374
    },
    "dusky-capped-flycatcher": {
        "name": "Dusky-capped flycatcher",
        "slug": "dusky-capped-flycatcher",
        "text": "",
        "duration": "T13S",
        "order": 14
    },
    "eastern-bluebird": {
        "name": "Eastern bluebird",
        "slug": "eastern-bluebird",
        "text": "",
        "duration": "T49S",
        "order": 521
    },
    "eastern-kingbird": {
        "name": "Eastern kingbird",
        "slug": "eastern-kingbird",
        "text": "",
        "duration": "T2M51S",
        "order": 330
    },
    "eastern-meadowlark": {
        "name": "Eastern meadowlark",
        "slug": "eastern-meadowlark",
        "text": "",
        "duration": "T47S",
        "order": 314
    },
    "eastern-phoebe": {
        "name": "Eastern phoebe",
        "slug": "eastern-phoebe",
        "text": "",
        "duration": "T2M41S",
        "order": 452
    },
    "eastern-screech-owl": {
        "name": "Eastern screech owl",
        "slug": "eastern-screech-owl",
        "text": "",
        "duration": "T36S",
        "order": 524
    },
    "eastern-spot-billed-duck": {
        "name": "Eastern spot-billed duck",
        "slug": "eastern-spot-billed-duck",
        "text": "",
        "duration": "T38S",
        "order": 26
    },
    "eastern-towhee": {
        "name": "Eastern towhee",
        "slug": "eastern-towhee",
        "text": "",
        "duration": "T2M43S",
        "order": 354
    },
    "eastern-whip-poor-will": {
        "name": "Eastern whip-poor-will",
        "slug": "eastern-whip-poor-will",
        "text": "",
        "duration": "T2M7S",
        "order": 200
    },
    "eastern-wood-pewee": {
        "name": "Eastern wood pewee",
        "slug": "eastern-wood-pewee",
        "text": "",
        "duration": "T14S",
        "order": 290
    },
    "elegant-tern": {
        "name": "Elegant tern",
        "slug": "elegant-tern",
        "text": "",
        "duration": "T37S",
        "order": 88
    },
    "elf-owl": {
        "name": "Elf owl",
        "slug": "elf-owl",
        "text": "",
        "duration": "T1M35S",
        "order": 520
    },
    "emperor-goose": {
        "name": "Emperor goose",
        "slug": "emperor-goose",
        "text": "",
        "duration": "T1M32S",
        "order": 298
    },
    "erckels-francolin": {
        "name": "Erckel's francolin",
        "slug": "erckels-francolin",
        "text": "",
        "duration": "T16S",
        "order": 19
    },
    "eurasian-collared-dove": {
        "name": "Eurasian collared dove",
        "slug": "eurasian-collared-dove",
        "text": "",
        "duration": "T13S",
        "order": 489
    },
    "eurasian-wigeon": {
        "name": "Eurasian wigeon",
        "slug": "eurasian-wigeon",
        "text": "",
        "duration": "T1M49S",
        "order": 365
    },
    "evening-grosbeak": {
        "name": "Evening grosbeak",
        "slug": "evening-grosbeak",
        "text": "",
        "duration": "T39S",
        "order": 369
    },
    "falcated-duck": {
        "name": "Falcated duck",
        "slug": "falcated-duck",
        "text": "",
        "duration": "T21S",
        "order": 82
    },
    "field-sparrow": {
        "name": "Field sparrow",
        "slug": "field-sparrow",
        "text": "",
        "duration": "T2M30S",
        "order": 253
    },
    "fish-crow": {
        "name": "Fish crow",
        "slug": "fish-crow",
        "text": "",
        "duration": "T29S",
        "order": 282
    },
    "five-striped-sparrow": {
        "name": "Five-striped sparrow",
        "slug": "five-striped-sparrow",
        "text": "",
        "duration": "T1M45S",
        "order": 2
    },
    "flammulated-owl": {
        "name": "Flammulated owl",
        "slug": "flammulated-owl",
        "text": "",
        "duration": "T17S",
        "order": 321
    },
    "florida-scrub-jay": {
        "name": "Florida scrub jay",
        "slug": "florida-scrub-jay",
        "text": "",
        "duration": "T11S",
        "order": 420
    },
    "forsters-tern": {
        "name": "Forster's tern",
        "slug": "forsters-tern",
        "text": "",
        "duration": "T25S",
        "order": 157
    },
    "fox-sparrow": {
        "name": "Fox sparrow",
        "slug": "fox-sparrow",
        "text": "",
        "duration": "T40S",
        "order": 386
    },
    "franklins-gull": {
        "name": "Franklin's gull",
        "slug": "franklins-gull",
        "text": "",
        "duration": "T13S",
        "order": 163
    },
    "fulvous-whistling-duck": {
        "name": "Fulvous whistling duck",
        "slug": "fulvous-whistling-duck",
        "text": "",
        "duration": "T20S",
        "order": 338
    },
    "gadwall": {
        "name": "Gadwall",
        "slug": "gadwall",
        "text": "",
        "duration": "T27S",
        "order": 532
    },
    "gambels-quail": {
        "name": "Gambel's quail",
        "slug": "gambels-quail",
        "text": "",
        "duration": "T32S",
        "order": 447
    },
    "gila-woodpecker": {
        "name": "Gila woodpecker",
        "slug": "gila-woodpecker",
        "text": "",
        "duration": "T59S",
        "order": 313
    },
    "gilded-flicker": {
        "name": "Gilded flicker",
        "slug": "gilded-flicker",
        "text": "",
        "duration": "T28S",
        "order": 162
    },
    "glaucous-gull": {
        "name": "Glaucous gull",
        "slug": "glaucous-gull",
        "text": "",
        "duration": "T24S",
        "order": 199
    },
    "glaucous-winged-gull": {
        "name": "Glaucous-winged gull",
        "slug": "glaucous-winged-gull",
        "text": "",
        "duration": "T2M0S",
        "order": 150
    },
    "glossy-ibis": {
        "name": "Glossy ibis",
        "slug": "glossy-ibis",
        "text": "",
        "duration": "T25S",
        "order": 446
    },
    "golden-eagle": {
        "name": "Golden eagle",
        "slug": "golden-eagle",
        "text": "As one of the largest birds in North America, Golden eagles are distinctive creatures. Although their name may misguide you.\n" +
            "Golden eagles are not in fact golden! They have a dark brown body with a golden sheen around their heads. While they have several white patches on their bodies, they darken as they grow older.\n" +
            "There’s something about open fields that attracts these creatures, as you can find them in hills, mountains, and basically the natural environment of the west of the United States. That’s probably why you see Golden eagles in Western movies a lot. So if you’re ever in an open field and you saw a bird flying in a V-shape like an arrow, it might be a Golden eagle.\n" +
            "Golden eagles usually fly alone or in pairs. Small mammals such as rabbits and marmots are typically the diet of a Golden eagle, but they might feed on small birds and reptiles as well. \n" +
            "They’re also larger than they appear in pictures. When perched, they are 27.6-33.1 in (70-84 cm) long, and their wings are 72.8-86.6 in (185-220 cm) once they’re spread and soaring. So it’s best not to underestimate them.",
        "duration": "T45S",
        "order": 595
    },
    "golden-cheeked-warbler": {
        "name": "Golden-cheeked warbler",
        "slug": "golden-cheeked-warbler",
        "text": "",
        "duration": "T44S",
        "order": 175
    },
    "golden-crowned-kinglet": {
        "name": "Golden-crowned kinglet",
        "slug": "golden-crowned-kinglet",
        "text": "",
        "duration": "T1M8S",
        "order": 471
    },
    "golden-crowned-sparrow": {
        "name": "Golden-crowned sparrow",
        "slug": "golden-crowned-sparrow",
        "text": "",
        "duration": "T5M8S",
        "order": 309
    },
    "golden-fronted-woodpecker": {
        "name": "Golden-fronted woodpecker",
        "slug": "golden-fronted-woodpecker",
        "text": "",
        "duration": "T2M35S",
        "order": 99
    },
    "golden-winged-warbler": {
        "name": "Golden-winged warbler",
        "slug": "golden-winged-warbler",
        "text": "",
        "duration": "T2M26S",
        "order": 198
    },
    "graces-warbler": {
        "name": "Grace's warbler",
        "slug": "graces-warbler",
        "text": "",
        "duration": "T2M51S",
        "order": 31
    },
    "grasshopper-sparrow": {
        "name": "Grasshopper sparrow",
        "slug": "grasshopper-sparrow",
        "text": "",
        "duration": "T37S",
        "order": 252
    },
    "gray-catbird": {
        "name": "Gray catbird",
        "slug": "gray-catbird",
        "text": "",
        "duration": "T1M21S",
        "order": 434
    },
    "gray-flycatcher": {
        "name": "Gray flycatcher",
        "slug": "gray-flycatcher",
        "text": "",
        "duration": "T1M12S",
        "order": 44
    },
    "gray-francolin": {
        "name": "Gray francolin",
        "slug": "gray-francolin",
        "text": "",
        "duration": "T49S",
        "order": 23
    },
    "gray-hawk": {
        "name": "Gray hawk",
        "slug": "gray-hawk",
        "text": "",
        "duration": "T1M3S",
        "order": 380
    },
    "gray-jay": {
        "name": "Gray jay",
        "slug": "gray-jay",
        "text": "",
        "duration": "T41S",
        "order": 427
    },
    "gray-kingbird": {
        "name": "Gray kingbird",
        "slug": "gray-kingbird",
        "text": "",
        "duration": "T13S",
        "order": 81
    },
    "gray-partridge": {
        "name": "Gray partridge",
        "slug": "gray-partridge",
        "text": "",
        "duration": "T53S",
        "order": 189
    },
    "gray-vireo": {
        "name": "Gray vireo",
        "slug": "gray-vireo",
        "text": "",
        "duration": "T6M15S",
        "order": 33
    },
    "gray-cheeked-thrush": {
        "name": "Gray-cheeked thrush",
        "slug": "gray-cheeked-thrush",
        "text": "",
        "duration": "T21S",
        "order": 135
    },
    "gray-crowned-rosy-finch": {
        "name": "Gray-crowned rosy finch",
        "slug": "gray-crowned-rosy-finch",
        "text": "",
        "duration": "T1M12S",
        "order": 36
    },
    "great-black-backed-gull": {
        "name": "Great black-backed gull",
        "slug": "great-black-backed-gull",
        "text": "",
        "duration": "T13S",
        "order": 435
    },
    "great-blue-heron": {
        "name": "Great blue heron",
        "slug": "great-blue-heron",
        "text": "A Great blue heron is one of those birds that makes you doubt whether it is real or is it a figment of imagination. Herons have long and slender legs and sinuous necks that make them look like question marks.\n" +
            "They are the largest kind of their species. Compared to a Great Egret they’re taller and much heavier, but they’re smaller and leaner than a Sandhill crane. They measure 38.2-53.9 in (97-137 cm) in length and weigh around 74.1-88.2 oz (2100-2500 g).\n" +
            "These herons have a pale blue-gray body that makes them aesthetically pleasing. They also have a wide black stripe over their eyes which gives them style.\n" +
            "These herons may live anywhere with water. So you can look for them in places like marshes, riverbanks, lakes, sloughs, open coasts, and backyard goldfish ponds. These herons usually stand like a statue or wade in shallow waters to look for fish. They may also eat salamanders, snakes, turtles, frogs, rodents, insects, and birds Once they’ve chosen prey, they use their sharp strong bills like a spear to catch them. Unlike how they hunt on the ground, herons choose places high off the ground to build their nests.",
        "duration": "T4S",
        "order": 579
    },
    "great-cormorant": {
        "name": "Great cormorant",
        "slug": "great-cormorant",
        "text": "",
        "duration": "T25S",
        "order": 463
    },
    "great-crested-flycatcher": {
        "name": "Great crested flycatcher",
        "slug": "great-crested-flycatcher",
        "text": "",
        "duration": "T24S",
        "order": 226
    },
    "great-egret": {
        "name": "Great egret",
        "slug": "great-egret",
        "text": 'The great egret (Ardea alba) is a large, white waterbird with a distinctive appearance and behavior. It is found in a wide range of wetland habitats, including marshes, swamps, and shallow lagoons, and is known for its elegant, graceful appearance and its long, slender neck and legs. In this article, we will explore the fascinating world of the great egret, including its physical characteristics, habitat, diet, behavior, and conservation status.\n\nPhysical Characteristics of Great Egrets\n\nGreat egrets are large birds, with a length of about 3.3 to 3.9 feet and a wingspan of about 5.2 to 5.6 feet. They have a distinctive appearance, with a long, slender neck and legs, a long, thin bill, and a long, rounded tail. They have a pure white plumage, with a white head, neck, and breast, and a white back and wings.\n\nMale and female great egrets are similar in appearance, but males are slightly larger. Juvenile great egrets are similar in appearance to adults, but have a brown, rather than a white, plumage.\n\nGreat egrets are known for their distinctive calls, which include a series of deep, guttural "kronk" calls. They also have a variety of softer, more subdued calls, which they use to communicate with each other.\n\nHabitat and Distribution of Great Egrets\n\nGreat egrets are found in a wide range of wetland habitats, including marshes, swamps, and shallow lagoons. They are found in a variety of habitats, including freshwater and saltwater wetlands, and are also found in gardens, parks, and other urban areas.\n\nIn their natural habitat, great egrets are found in wetland habitats, where they can find food and shelter in the form of fish, frogs, insects, and other small animals. They are adapted to living in wet, marshy environments and are able to thrive in the harsh conditions of these habitats. In urban areas, they are often found in gardens, parks, and other green spaces, where they can find food and shelter.\n\nDiet and Feeding Behavior of Great Egrets\n\nGreat egrets are carnivorous, meaning they eat animals. Their diet consists of fish, frogs, insects, and other small animals. They are opportunistic feeders and will eat whatever food is available to them.\n\nGreat egrets are gregarious birds and are often seen in large flocks. They are known to forage for food in shallow water, using their long, thin bills to catch prey. They are also known to hunt from the air, using their keen eyesight to locate prey.\n\nBehavior and Communication of Great Egrets\n\nGreat egrets are social birds and are often seen in large flocks. They are vocal birds and have a variety of different calls and songs, which they use to communicate with each other and to defend their territory.\n\nMale great egrets are known for their distinctive songs, which they use to attract mates and defend their territory. They have a variety of different songs, including a series of deep, guttural "kronk" calls. Female great egrets are less vocal and tend to give shorter, softer calls.\n\nGreat egrets are territorial birds and will defend their territory from other egrets and other birds. They are also known to be aggressive towards other birds at feeding stations, and will often dominate and exclude other species from feeding areas.',
        "duration": "T1M5S",
        "order": 569
    },
    "great-gray-owl": {
        "name": "Great gray owl",
        "slug": "great-gray-owl",
        "text": "",
        "duration": "T1M47S",
        "order": 379
    },
    "great-gray-shrike": {
        "name": "Great Gray Shrike",
        "slug": "great-gray-shrike",
        "text": "",
        "duration": "T7S",
        "order": 8
    },
    "great-horned-owl": {
        "name": "Great horned owl",
        "slug": "great-horned-owl",
        "text": "They may look like they’re always scowling and angry at you, but Great horned owls have a reputation for their terrorizing gaze. They have ear-like tufts and emit a deep hooting voice, which makes them seem like a creature from fantasy books.\n" +
            "This great owl is as intimidating as he looks. He chooses mammals and birds as his prey and they’re sometimes even larger than himself. Some of this owl’s awe-inspiring prey include Peregrine Falcons, Ospreys, and  Prairie Falcons.\n" +
            "As one of the most common owls in North America, Great horned owls may choose any semi-open area as their habitat. This includes any wetland, grassland, forest, desert, city, and backyard between the tropics and the Arctic. These owls have strong clenching talons that require 28 pounds-force to be open. As their arch enemy, American Crows sometimes corner up a Great horned owl and harass him for hours! So if ever heard a cawing group of American Crows, you may suspect that they’re up to something.\n" +
            "Unlike many animals, the female Great horned owls are larger than their male counterparts. Their size is around 18 to 25 inches and they weigh around 2 to 5.5 pounds.",
        "duration": "T4M12S",
        "order": 587
    },
    "great-skua": {
        "name": "Great skua",
        "slug": "great-skua",
        "text": "",
        "duration": "T7S",
        "order": 239
    },
    "greater-pewee": {
        "name": "Greater pewee",
        "slug": "greater-pewee",
        "text": "",
        "duration": "T2M59S",
        "order": 9
    },
    "greater-prairie-chicken": {
        "name": "Greater prairie chicken",
        "slug": "greater-prairie-chicken",
        "text": "",
        "duration": "T30S",
        "order": 368
    },
    "greater-roadrunner": {
        "name": "Greater roadrunner",
        "slug": "greater-roadrunner",
        "text": 'The greater roadrunner (Geococcyx californianus) is a medium-sized bird with a distinctive appearance and behavior. It is found in a wide range of habitats across much of the southwestern United States and parts of Mexico, and is known for its long, slender build, its long, tail, and its fondness for insects and other small prey. In this article, we will explore the fascinating world of the greater roadrunner, including its physical characteristics, habitat, diet, behavior, and conservation status.\n\nPhysical Characteristics of Greater Roadrunners\n\nGreater roadrunners are medium-sized birds, with a length of about 22 to 24 inches and a wingspan of about 24 to 29 inches. They have a distinctive appearance, with a long, slender build, a long, pointed tail, and a large, round head. They have a dark brown and black plumage, with a white breast and a white stripe running down their belly.\n\nMale and female greater roadrunners are similar in appearance, but males are slightly larger. Juvenile greater roadrunners are similar in appearance to adults, but have a more mottled, speckled plumage.\n\nGreater roadrunners are known for their distinctive calls, which include a series of deep, guttural "caws" and "caws." They also have a variety of softer, more subdued calls, which they use to communicate with each other.\n\nHabitat and Distribution of Greater Roadrunners\n\nGreater roadrunners are found in a wide range of habitats across much of the southwestern United States and parts of Mexico, including deserts, grasslands, and wooded areas. They are found in a variety of habitats, including deciduous forests, coniferous forests, and mixed forests. They are also found in gardens, parks, and other green spaces.\n\nIn their natural habitat, greater roadrunners are found in open, arid environments, where they can find food and shelter in the form of insects, worms, and other small prey. They are adapted to living in desert environments and are able to thrive in the hot, dry conditions of these habitats.\n\nDiet and Feeding Behavior of Greater Roadrunners\n\nGreater roadrunners are carnivorous, meaning they eat animals. Their diet consists of insects, worms, lizards, and other small prey. They are opportunistic feeders and will eat whatever prey is available to them.\n\nGreater roadrunners are active during the day and are often seen foraging for food in open, arid environments. They are known to feed on a variety of insects, including beetles, ants, and grasshoppers, as well as worms and other small prey. They are also known to feed on lizards, snakes, and other small reptiles.\n\nBehavior and Communication of Greater Roadrunners\n\nGreater roadrunners are solitary birds and are often seen alone or in pairs. They are vocal birds and have a variety of different calls and songs, which they use to communicate with each other and to defend their territory.\n\nMale greater roadrunners are known for their distinctive calls, which they use to attract mates and defend their territory. They have a variety of different calls, including a series of deep, guttural "caws" and "caws." Female greater roadrunners are less vocal and tend to give shorter, softer calls.',
        "duration": "T1M10S",
        "order": 560
    },
    "greater-sage-grouse": {
        "name": "Greater sage-grouse",
        "slug": "greater-sage-grouse",
        "text": "",
        "duration": "T26S",
        "order": 419
    },
    "greater-scaup": {
        "name": "Greater scaup",
        "slug": "greater-scaup",
        "text": "",
        "duration": "T38S",
        "order": 349
    },
    "greater-white-fronted-goose": {
        "name": "Greater white-fronted goose",
        "slug": "greater-white-fronted-goose",
        "text": "",
        "duration": "T16S",
        "order": 342
    },
    "greater-yellowlegs": {
        "name": "Greater yellowlegs",
        "slug": "greater-yellowlegs",
        "text": "",
        "duration": "T39S",
        "order": 289
    },
    "great-tailed-grackle": {
        "name": "Great-tailed grackle",
        "slug": "great-tailed-grackle",
        "text": "",
        "duration": "T7S",
        "order": 445
    },
    "green-heron": {
        "name": "Green heron",
        "slug": "green-heron",
        "text": "",
        "duration": "T25S",
        "order": 537
    },
    "green-kingfisher": {
        "name": "Green kingfisher",
        "slug": "green-kingfisher",
        "text": "",
        "duration": "T13S",
        "order": 161
    },
    "green-tailed-towhee": {
        "name": "Green-tailed towhee",
        "slug": "green-tailed-towhee",
        "text": "",
        "duration": "T57S",
        "order": 76
    },
    "grey-plover": {
        "name": "Grey Plover",
        "slug": "grey-plover",
        "text": "",
        "duration": "T1M7S",
        "order": 251
    },
    "groove-billed-ani": {
        "name": "Groove-billed ani",
        "slug": "groove-billed-ani",
        "text": "",
        "duration": "T1M31S",
        "order": 174
    },
    "gull-billed-tern": {
        "name": "Gull-billed tern",
        "slug": "gull-billed-tern",
        "text": "",
        "duration": "T15S",
        "order": 134
    },
    "gunnison-grouse": {
        "name": "Gunnison grouse",
        "slug": "gunnison-grouse",
        "text": "",
        "duration": "T24S",
        "order": 18
    },
    "gyrfalcon": {
        "name": "Gyrfalcon",
        "slug": "gyrfalcon",
        "text": "",
        "duration": "T42S",
        "order": 552
    },
    "hairy-woodpecker": {
        "name": "Hairy woodpecker",
        "slug": "hairy-woodpecker",
        "text": "",
        "duration": "T55S",
        "order": 492
    },
    "hammonds-flycatcher": {
        "name": "Hammond's flycatcher",
        "slug": "hammonds-flycatcher",
        "text": "",
        "duration": "T3M50S",
        "order": 329
    },
    "harlequin-duck": {
        "name": "Harlequin duck",
        "slug": "harlequin-duck",
        "text": "",
        "duration": "T1M43S",
        "order": 514
    },
    "harriss-hawk": {
        "name": "Harris's hawk",
        "slug": "harriss-hawk",
        "text": "",
        "duration": "T27S",
        "order": 551
    },
    "harriss-sparrow": {
        "name": "Harris's sparrow",
        "slug": "harriss-sparrow",
        "text": "",
        "duration": "T31S",
        "order": 188
    },
    "heermanns-gull": {
        "name": "Heermann's gull",
        "slug": "heermanns-gull",
        "text": "",
        "duration": "T9S",
        "order": 133
    },
    "henslows-sparrow": {
        "name": "Henslow's sparrow",
        "slug": "henslows-sparrow",
        "text": "",
        "duration": "T31S",
        "order": 87
    },
    "hermit-thrush": {
        "name": "Hermit thrush",
        "slug": "hermit-thrush",
        "text": "",
        "duration": "T5M24S",
        "order": 457
    },
    "hermit-warbler": {
        "name": "Hermit warbler",
        "slug": "hermit-warbler",
        "text": "",
        "duration": "T4M40S",
        "order": 49
    },
    "hooded-merganser": {
        "name": "Hooded merganser",
        "slug": "hooded-merganser",
        "text": "",
        "duration": "T8S",
        "order": 544
    },
    "hooded-oriole": {
        "name": "Hooded oriole",
        "slug": "hooded-oriole",
        "text": "",
        "duration": "T1M27S",
        "order": 210
    },
    "hooded-warbler": {
        "name": "Hooded warbler",
        "slug": "hooded-warbler",
        "text": "",
        "duration": "T19S",
        "order": 238
    },
    "horned-grebe": {
        "name": "Horned grebe",
        "slug": "horned-grebe",
        "text": "",
        "duration": "T3S",
        "order": 264
    },
    "horned-lark": {
        "name": "Horned lark",
        "slug": "horned-lark",
        "text": "",
        "duration": "T22S",
        "order": 328
    },
    "house-finch": {
        "name": "House finch",
        "slug": "house-finch",
        "text": 'The house finch (Haemorhous mexicanus) is a small, colorful bird with a distinctive appearance and behavior. It is found in a wide range of habitats across much of the United States and parts of Canada, and is known for its striking plumage, its fondness for seeds and fruit, and its distinctive calls. In this article, we will explore the fascinating world of the house finch, including its physical characteristics, habitat, diet, behavior, and conservation status.\n\nPhysical Characteristics of House Finches\n\nHouse finches are small birds, with a length of about 5 to 6 inches and a wingspan of about 8 to 9 inches. They have a distinctive appearance, with a small, round head, a short, thin bill, and a long, pointed tail. They have a striking plumage, with a brown back and wings, and a reddish breast, head, and face.\n\nMale and female house finches are similar in appearance, but males have a brighter, more colorful plumage. Juvenile house finches are similar in appearance to adults, but have a more muted, brownish plumage.\n\nHouse finches are known for their distinctive calls, which include a series of soft, warbling "cheee" and "cheee" sounds. They also have a variety of softer, more subdued calls, which they use to communicate with each other.\n\nHabitat and Distribution of House Finches\n\nHouse finches are found in a wide range of habitats across much of the United States and parts of Canada, including forests, woodlands, grasslands, and urban areas. They are found in a variety of habitats, including deciduous forests, coniferous forests, and mixed forests. They are also found in gardens, parks, and other green spaces.\n\nIn their natural habitat, house finches are found in wooded areas, where they can find food and shelter in the form of seeds, fruit, and insects. They are adapted to living in forested environments and are able to thrive in the dense canopy of these habitats. In urban areas, they are often found in gardens, parks, and other green spaces, where they can find food and shelter.\n\nDiet and Feeding Behavior of House Finches\n\nHouse finches are omnivorous, meaning they eat both plants and animals. Their diet consists of seeds, fruit, and insects. They are opportunistic feeders and will eat whatever food is available to them.\n\nHouse finches are active during the day and are often seen foraging for food in trees, bushes, and other wooded areas. They are known to feed on a variety of seeds, including sunflower seeds, safflower seeds, and millet seeds. They are also known to feed on fruit, including berries, cherries, and grapes. They are also known to feed on insects, including beetles, ants, and grasshoppers.\n\nBehavior and Communication of House Finches\n\nHouse finches are social birds and are often seen in pairs or small groups. They are vocal birds and have a variety of different calls and songs, which they use to communicate with each other and to defend their territory.\n\nMale house finches are known for their distinctive calls, which they use to attract mates and defend their territory.',
        "duration": "T20S",
        "order": 558
    },
    "house-sparrow": {
        "name": "House sparrow",
        "slug": "house-sparrow",
        "text": 'The house sparrow (Passer domesticus) is a small, plump bird with a distinctive brown, grey, and black plumage. It is a familiar sight in gardens, parks, and urban areas across much of the world, and is one of the most common and widespread birds on the planet. In this article, we will explore the fascinating world of the house sparrow, including its physical characteristics, habitat, diet, behavior, and conservation status.\n\nPhysical Characteristics of House Sparrows\n\nHouse sparrows are small birds, with a length of about 5 to 6 inches and a wingspan of about 7 to 8 inches. They are stocky and plump, with a large, rounded head, short neck, and short, conical beak. Their wings are short and rounded, and they have a long, squared-off tail.\n\nMale and female house sparrows are similar in appearance, but males are slightly larger and have a more colorful plumage. Males have a distinctive black bib on their chest and a black patch on their throat, as well as brown, grey, and black markings on their wings and back. Female house sparrows are generally duller in color, with more muted brown, grey, and black markings. Juvenile house sparrows are similar in appearance to females, but have a streaked breast and a pale brown crown.\n\nHabitat and Distribution of House Sparrows\n\nHouse sparrows are found in a wide variety of habitats, including gardens, parks, farmland, and urban areas. They are most commonly found in areas with a human presence, as they rely on humans for food and shelter. They are native to Europe, Asia, and the Middle East, but have been introduced to many other parts of the world, including North America, South America, Australia, and New Zealand.\n\nIn their native range, house sparrows are found in a variety of habitats, including forests, grasslands, and agricultural areas. They are adaptable birds and are able to thrive in a wide range of environments. In non-native areas, they are often found in urban environments, where they can find food and shelter in the form of bird feeders, gardens, and buildings.\n\nDiet and Feeding Behavior of House Sparrows\n\nHouse sparrows are omnivorous, meaning they eat both plants and animals. Their diet consists of seeds, grains, fruit, insects, and occasionally small invertebrates. They are opportunistic feeders and will eat whatever food is available to them.\n\nHouse sparrows are social birds and often feed in flocks. They are commonly seen at bird feeders, where they will feed on seeds and grains. They are also known to scavenge for food in gardens and parks, and will often feed on the seeds and fruits of various plants.\n\nBehavior and Communication of House Sparrows\n\nHouse sparrows are highly social birds and are often seen in flocks. They are vocal birds and have a variety of different calls and songs, which they use to communicate with each other and to defend their territory.\n\nMale house sparrows are known for their distinctive songs, which they use to attract mates and defend their territory. They have a variety of different songs, including a sharp "chirp" and a series of short, buzzy notes. Female house sparrows are less vocal and tend to give shorter, softer calls.\n\nHouse sparrows are territorial birds and will defend their territory from other sparrows and other birds. They are also known to be aggressive towards other birds at feeding stations, and will often dominate and exclude other species from feeding areas.',
        "duration": "T1M47S",
        "order": 578
    },
    "house-wren": {
        "name": "House wren",
        "slug": "house-wren",
        "text": "",
        "duration": "T34S",
        "order": 491
    },
    "hudsonian-godwit": {
        "name": "Hudsonian godwit",
        "slug": "hudsonian-godwit",
        "text": "",
        "duration": "T30S",
        "order": 149
    },
    "huttons-vireo": {
        "name": "Hutton's vireo",
        "slug": "huttons-vireo",
        "text": "",
        "duration": "T33S",
        "order": 90
    },
    "inca-dove": {
        "name": "Inca dove",
        "slug": "inca-dove",
        "text": "",
        "duration": "T17S",
        "order": 250
    },
    "indigo-bunting": {
        "name": "Indigo bunting",
        "slug": "indigo-bunting",
        "text": "",
        "duration": "T1M30S",
        "order": 510
    },
    "jabiru": {
        "name": "Jabiru",
        "slug": "jabiru",
        "text": "",
        "duration": "T46S",
        "order": 509
    },
    "juniper-titmouse": {
        "name": "Juniper titmouse",
        "slug": "juniper-titmouse",
        "text": "",
        "duration": "T2M12S",
        "order": 72
    },
    "kentucky-warbler": {
        "name": "Kentucky warbler",
        "slug": "kentucky-warbler",
        "text": "",
        "duration": "T18S",
        "order": 120
    },
    "killdeer": {
        "name": "Killdeer",
        "slug": "killdeer",
        "text": "",
        "duration": "T1M31S",
        "order": 542
    },
    "king-eider": {
        "name": "King eider",
        "slug": "king-eider",
        "text": "",
        "duration": "T34S",
        "order": 438
    },
    "king-rail": {
        "name": "King rail",
        "slug": "king-rail",
        "text": "",
        "duration": "T25S",
        "order": 249
    },
    "kirtlands-warbler": {
        "name": "Kirtland's warbler",
        "slug": "kirtlands-warbler",
        "text": "",
        "duration": "T51S",
        "order": 308
    },
    "ladder-backed-woodpecker": {
        "name": "Ladder-backed woodpecker",
        "slug": "ladder-backed-woodpecker",
        "text": "",
        "duration": "T14S",
        "order": 281
    },
    "lapland-longspur": {
        "name": "Lapland longspur",
        "slug": "lapland-longspur",
        "text": "",
        "duration": "T49S",
        "order": 173
    },
    "lark-bunting": {
        "name": "Lark bunting",
        "slug": "lark-bunting",
        "text": "",
        "duration": "T2M1S",
        "order": 320
    },
    "lark-sparrow": {
        "name": "Lark sparrow",
        "slug": "lark-sparrow",
        "text": "",
        "duration": "T42S",
        "order": 197
    },
    "laughing-gull": {
        "name": "Laughing gull",
        "slug": "laughing-gull",
        "text": "",
        "duration": "T13S",
        "order": 391
    },
    "lawrences-goldfinch": {
        "name": "Lawrence's goldfinch",
        "slug": "lawrences-goldfinch",
        "text": "",
        "duration": "T1M40S",
        "order": 53
    },
    "laysan-albatross": {
        "name": "Laysan albatross",
        "slug": "laysan-albatross",
        "text": "",
        "duration": "T4M10S",
        "order": 418
    },
    "lazuli-bunting": {
        "name": "Lazuli bunting",
        "slug": "lazuli-bunting",
        "text": "",
        "duration": "T1M5S",
        "order": 263
    },
    "le-contes-sparrow": {
        "name": "Le Conte's sparrow",
        "slug": "le-contes-sparrow",
        "text": "",
        "duration": "T1M49S",
        "order": 7
    },
    "le-contes-thrasher": {
        "name": "Le Conte's thrasher",
        "slug": "le-contes-thrasher",
        "text": "",
        "duration": "T1M1S",
        "order": 1
    },
    "least-bittern": {
        "name": "Least bittern",
        "slug": "least-bittern",
        "text": "",
        "duration": "T50S",
        "order": 262
    },
    "least-flycatcher": {
        "name": "Least flycatcher",
        "slug": "least-flycatcher",
        "text": "",
        "duration": "T3M56S",
        "order": 187
    },
    "least-grebe": {
        "name": "Least grebe",
        "slug": "least-grebe",
        "text": "",
        "duration": "T20S",
        "order": 47
    },
    "least-sandpiper": {
        "name": "Least sandpiper",
        "slug": "least-sandpiper",
        "text": "",
        "duration": "T49S",
        "order": 280
    },
    "least-tern": {
        "name": "Least tern",
        "slug": "least-tern",
        "text": "",
        "duration": "T17S",
        "order": 279
    },
    "lesser-goldfinch": {
        "name": "Lesser goldfinch",
        "slug": "lesser-goldfinch",
        "text": "",
        "duration": "T28S",
        "order": 407
    },
    "lesser-nighthawk": {
        "name": "Lesser nighthawk",
        "slug": "lesser-nighthawk",
        "text": "",
        "duration": "T3M15S",
        "order": 101
    },
    "lesser-prairie-chicken": {
        "name": "Lesser prairie chicken",
        "slug": "lesser-prairie-chicken",
        "text": "",
        "duration": "T23S",
        "order": 220
    },
    "lesser-scaup": {
        "name": "Lesser scaup",
        "slug": "lesser-scaup",
        "text": "",
        "duration": "T34S",
        "order": 397
    },
    "lesser-yellowlegs": {
        "name": "Lesser yellowlegs",
        "slug": "lesser-yellowlegs",
        "text": "",
        "duration": "T9S",
        "order": 261
    },
    "lewiss-woodpecker": {
        "name": "Lewis's woodpecker",
        "slug": "lewiss-woodpecker",
        "text": "",
        "duration": "T22S",
        "order": 248
    },
    "limpkin": {
        "name": "Limpkin",
        "slug": "limpkin",
        "text": "",
        "duration": "T17S",
        "order": 378
    },
    "lincolns-sparrow": {
        "name": "Lincoln's sparrow",
        "slug": "lincolns-sparrow",
        "text": "",
        "duration": "T55S",
        "order": 307
    },
    "little-blue-heron": {
        "name": "Little blue heron",
        "slug": "little-blue-heron",
        "text": "",
        "duration": "T44S",
        "order": 456
    },
    "little-gull": {
        "name": "Little gull",
        "slug": "little-gull",
        "text": "",
        "duration": "T9S",
        "order": 209
    },
    "loggerhead-shrike": {
        "name": "Loggerhead shrike",
        "slug": "loggerhead-shrike",
        "text": "",
        "duration": "T2M34S",
        "order": 472
    },
    "long-billed-curlew": {
        "name": "Long-billed curlew",
        "slug": "long-billed-curlew",
        "text": "",
        "duration": "T24S",
        "order": 352
    },
    "long-billed-dowitcher": {
        "name": "Long-billed dowitcher",
        "slug": "long-billed-dowitcher",
        "text": "",
        "duration": "T22S",
        "order": 219
    },
    "long-billed-thrasher": {
        "name": "Long-billed thrasher",
        "slug": "long-billed-thrasher",
        "text": "",
        "duration": "T1M46S",
        "order": 64
    },
    "long-eared-owl": {
        "name": "Long-eared owl",
        "slug": "long-eared-owl",
        "text": "",
        "duration": "T52S",
        "order": 519
    },
    "long-tailed-duck": {
        "name": "Long-tailed duck",
        "slug": "long-tailed-duck",
        "text": "",
        "duration": "T48S",
        "order": 417
    },
    "long-tailed-jaeger": {
        "name": "Long-tailed jaeger",
        "slug": "long-tailed-jaeger",
        "text": "",
        "duration": "T7S",
        "order": 119
    },
    "louisiana-waterthrush": {
        "name": "Louisiana waterthrush",
        "slug": "louisiana-waterthrush",
        "text": "",
        "duration": "T19S",
        "order": 68
    },
    "lucifer-hummingbird": {
        "name": "Lucifer hummingbird",
        "slug": "lucifer-hummingbird",
        "text": "",
        "duration": "T15S",
        "order": 96
    },
    "lucys-warbler": {
        "name": "Lucy's warbler",
        "slug": "lucys-warbler",
        "text": "",
        "duration": "T47S",
        "order": 39
    },
    "macgillivrays-warbler": {
        "name": "MacGillivray's warbler",
        "slug": "macgillivrays-warbler",
        "text": "",
        "duration": "T53S",
        "order": 98
    },
    "magnificent-hummingbird": {
        "name": "Magnificent hummingbird",
        "slug": "magnificent-hummingbird",
        "text": "",
        "duration": "T15S",
        "order": 46
    },
    "magnolia-warbler": {
        "name": "Magnolia warbler",
        "slug": "magnolia-warbler",
        "text": "",
        "duration": "T19S",
        "order": 367
    },
    "mallard": {
        "name": "Mallard",
        "slug": "mallard",
        "text": "Mallards are like most ducks, but they’re relatively larger than most of them. These ducks weigh about 35.3-45.9 oz (1000-1300 g) and 19.7-25.6 in (50-65 cm) in length. They’re fairly larger than teal and much smaller than a Canada Goose.\n" +
            "Mallards have an interesting color pattern, as the male of the species looks much different from the females and juveniles. The male is noticeable for his yellow bill and iridescent-green head. Although most of his body is brown, they turn into black on his rear. The female, however, has brown and orange bills with a mottled brown body.\n" +
            "Like most ducks, Mallard loves wet places, regardless of whether the place is natural or artificial.\n" +
            "So you can find them in ponds, rivers, lakes, marshes, city parks, and backyards. Mallards are considered dabbling ducks. This means they rarely dive into the water and rather lean forward and graze on underwater plants.\n" +
            "If you’re looking for a friendly duck, Mallards are the right choice for you. They can be easily tamed and gather around with other species of ducks. So if you ever see Mallards in city ponds, you might be friendly and you can approach them.",
        "duration": "T1M0S",
        "order": 586
    },
    "mangrove-cuckoo": {
        "name": "Mangrove cuckoo",
        "slug": "mangrove-cuckoo",
        "text": "",
        "duration": "T20S",
        "order": 57
    },
    "manx-shearwater": {
        "name": "Manx shearwater",
        "slug": "manx-shearwater",
        "text": "",
        "duration": "T1M54S",
        "order": 361
    },
    "marbled-godwit": {
        "name": "Marbled godwit",
        "slug": "marbled-godwit",
        "text": "",
        "duration": "T4S",
        "order": 196
    },
    "marbled-murrelet": {
        "name": "Marbled murrelet",
        "slug": "marbled-murrelet",
        "text": "",
        "duration": "T8S",
        "order": 312
    },
    "marsh-wren": {
        "name": "Marsh wren",
        "slug": "marsh-wren",
        "text": "",
        "duration": "T2M41S",
        "order": 260
    },
    "masked-booby": {
        "name": "Masked booby",
        "slug": "masked-booby",
        "text": "",
        "duration": "T4S",
        "order": 247
    },
    "masked-duck": {
        "name": "Masked duck",
        "slug": "masked-duck",
        "text": "",
        "duration": "T21S",
        "order": 143
    },
    "mccowns-longspur": {
        "name": "McCown's longspur",
        "slug": "mccowns-longspur",
        "text": "",
        "duration": "T1M23S",
        "order": 25
    },
    "merlin": {
        "name": "Merlin",
        "slug": "merlin",
        "text": "If you’ve ever wondered what a cross between a falcon and a pigeon looks like, then you can look at a Merlin and find out. This bird which carries the name of a wizard is the UK’s smallest bird of prey. It’s only 25-30cm long with its wings spanning 50-62cm.Merlin usually eats smaller birds and the male (125-234g) is lighter than the female (164-300g).\n" +
            "You’re more likely to spot them in the north of Britain and Ireland, but in the winter they migrate south for warmer weather along with other Icelandic breeding birds. Unfortunately, Merlins faced a population disaster in the late 20th century and they’re still recovering from it.\n" +
            "Merlins are somewhat monogamous and they usually breed during May/June. They look for a mate once they reach their first birthday and typically lay 3 to 5 eggs. Merlins also have a great relationship with humans.\n" +
            "They were a popular choice for falconry in medieval Europe. Merlins have a long and square-shaped tail with broad wings that pierce the air like an airplane. They hold their wings close when gliding. So if you want to spot a Merlin, look for these features.\n",
        "duration": "T39S",
        "order": 600
    },
    "mew-gull": {
        "name": "Mew gull",
        "slug": "mew-gull",
        "text": "",
        "duration": "T2M16S",
        "order": 156
    },
    "mexican-jay": {
        "name": "Mexican jay",
        "slug": "mexican-jay",
        "text": "",
        "duration": "T15S",
        "order": 148
    },
    "mexican-whip-poor-will": {
        "name": "Mexican whip-poor-will",
        "slug": "mexican-whip-poor-will",
        "text": "",
        "duration": "T26S",
        "order": 20
    },
    "mississippi-kite": {
        "name": "Mississippi kite",
        "slug": "mississippi-kite",
        "text": "",
        "duration": "T2M56S",
        "order": 406
    },
    "monk-parakeet": {
        "name": "Monk parakeet",
        "slug": "monk-parakeet",
        "text": 'The monk parakeet (Myiopsitta monachus), also known as the Quaker parakeet, is a medium-sized parrot with a distinctive appearance and behavior. It is native to South America, but has been introduced to many other parts of the world, including the United States, where it is now considered an invasive species. In this article, we will explore the fascinating world of the monk parakeet, including its physical characteristics, habitat, diet, behavior, and conservation status.\n\nPhysical Characteristics of Monk Parakeets\n\nMonk parakeets are medium-sized parrots, with a length of about 12 inches and a wingspan of about 18 inches. They have a distinctive appearance, with a small, round head, a short, curved beak, and a long, pointed tail. They have a striking plumage, with a green body, a gray chest and head, and a blue-tipped tail.\n\nMale and female monk parakeets are similar in appearance, but males have a brighter, more colorful plumage. Juvenile monk parakeets are similar in appearance to adults, but have a more muted, brownish plumage.\n\nMonk parakeets are known for their distinctive calls, which include a variety of high-pitched chirps, squawks, and screeches. They also have a variety of softer, more subdued calls, which they use to communicate with each other.\n\nHabitat and Distribution of Monk Parakeets\n\nMonk parakeets are native to South America, where they are found in a wide range of habitats, including forests, grasslands, and savannas. They are also found in urban areas, where they have adapted to living in close proximity to humans.\n\nIn their native habitat, monk parakeets are found in wooded areas, where they can find food and shelter in the form of seeds, fruit, and insects. They are adapted to living in forested environments and are able to thrive in the dense canopy of these habitats. In urban areas, they are often found in gardens, parks, and other green spaces, where they can find food and shelter.\n\nMonk parakeets have been introduced to many other parts of the world, including the United States, where they have established populations in many states, including Florida, Texas, and California. They are considered an invasive species in the United States and are known to cause problems for native birds and plants.\n\nDiet and Feeding Behavior of Monk Parakeets\n\nMonk parakeets are omnivorous, meaning they eat both plants and animals. Their diet consists of seeds, fruit, insects, and other small prey. They are opportunistic feeders and will eat whatever food is available to them.\n\nMonk parakeets are active during the day and are often seen foraging for food in trees, bushes, and other wooded areas. They are known to feed on a variety of seeds, including sunflower seeds, safflower seeds, and millet seeds. They are also known to feed on fruit, including berries, cherries, and grapes. They are also known to feed on insects, including beetles, ants, and grasshoppers.\n\nBehavior and Communication of Monk Parakeets\n\nMonk parakeets are social birds and are often seen in pairs or small groups.',
        "duration": "T1M42S",
        "order": 555
    },
    "montezuma-quail": {
        "name": "Montezuma quail",
        "slug": "montezuma-quail",
        "text": "",
        "duration": "T11S",
        "order": 186
    },
    "mottled-duck": {
        "name": "Mottled duck",
        "slug": "mottled-duck",
        "text": "",
        "duration": "T11S",
        "order": 387
    },
    "mountain-bluebird": {
        "name": "Mountain bluebird",
        "slug": "mountain-bluebird",
        "text": "",
        "duration": "T39S",
        "order": 549
    },
    "mountain-chickadee": {
        "name": "Mountain chickadee",
        "slug": "mountain-chickadee",
        "text": "",
        "duration": "T1M26S",
        "order": 297
    },
    "mountain-plover": {
        "name": "Mountain plover",
        "slug": "mountain-plover",
        "text": "",
        "duration": "T8S",
        "order": 118
    },
    "mountain-quail": {
        "name": "Mountain quail",
        "slug": "mountain-quail",
        "text": "",
        "duration": "T2M30S",
        "order": 414
    },
    "mourning-dove": {
        "name": "Mourning dove",
        "slug": "mourning-dove",
        "text": "Although their names sound poetic, Mourning doves are not some fantasy bizarre birds. In fact, anyone has probably seen them at least once in their lives.\n" +
            "These doves have a narrow tail and a small head. They’re mostly brown and gray and are seen in cities and urban areas more than perhaps any other bird.\n" +
            "They usually perch on telephone wires and look for seeds or bread crumbs on the ground. So if you leave some seeds outside your window or in your backyard, chances are you’ll face plenty of Mourning doves soon.\n" +
            "Their interesting name is inspired by their calls which are soft and drawn-out like a lament. Mourning doves are agile and swift when it comes to flying. Even their take-off makes a sharp whistling sound which only adds to their graceful behavior.\n" +
            "Doves are not very good at defending themselves and they are frequently hunted by hawks, squirrels, snakes, raccoons, owls, dogs, cats, and even humans.\n" +
            "Nevertheless, their population still stands strong as one of the most abundant birds with an estimated 350 million doves in the United States alone. Outside cities, Mourning doves can be found in open woodlands, nesting, and mating on scattered trees.",
        "duration": "T2M45S",
        "order": 580
    },
    "mourning-warbler": {
        "name": "Mourning warbler",
        "slug": "mourning-warbler",
        "text": "",
        "duration": "T1M34S",
        "order": 172
    },
    "muscovy-duck": {
        "name": "Muscovy duck",
        "slug": "muscovy-duck",
        "text": "Though his outline looks like a duck, the strange-looking Muscovy duck may not remind you of a duck at first glance. These birds have glossy black bodies with white breasts. Their wings may be an exotic green or blue.\n" +
            "It’s not that difficult to recognize a Muscovy duck.All you have to do is look for their size and check their faces. If they’re large and have a long neck and red, warty facial skin, chances are you’re looking at Muscovy ducks.\n" +
            "Muscovy duck belongs to the Americas. You can find them from the Rio Grande Valley of Texas and Mexico south to Argentina and Uruguay. You may also find domesticated versions of them in local parks and farms.\n" +
            "These ducks love to reside in the forest and choose a tree cavity to build their nest in. The male and female Muscovy ducks have a huge difference. While the male is considered the largest duck in North America, the female is only half his size. They often live in pairs, but they’re not monogamous. Muscovy ducks may choose multiple mates.\n" +
            "They’re also not very picky when it comes to food. They may eat anything from plants to small insects.",
        "duration": "T22S",
        "order": 582
    },
    "mute-swan": {
        "name": "Mute swan",
        "slug": "mute-swan",
        "text": "",
        "duration": "T2M50S",
        "order": 550
    },
    "nashville-warbler": {
        "name": "Nashville warbler",
        "slug": "nashville-warbler",
        "text": "",
        "duration": "T1M18S",
        "order": 348
    },
    "nelsons-sparrow": {
        "name": "Nelson's sparrow",
        "slug": "nelsons-sparrow",
        "text": "",
        "duration": "T58S",
        "order": 142
    },
    "neotropic-cormorant": {
        "name": "Neotropic cormorant",
        "slug": "neotropic-cormorant",
        "text": "",
        "duration": "T35S",
        "order": 195
    },
    "northern-beardless-tyrannulet": {
        "name": "Northern beardless tyrannulet",
        "slug": "northern-beardless-tyrannulet",
        "text": "",
        "duration": "T15S",
        "order": 3
    },
    "northern-bobwhite": {
        "name": "Northern bobwhite",
        "slug": "northern-bobwhite",
        "text": "",
        "duration": "T18S",
        "order": 390
    },
    "northern-cardinal": {
        "name": "Northern cardinal",
        "slug": "northern-cardinal",
        "text": 'The northern cardinal (Cardinalis cardinalis) is a medium-sized songbird with a distinctive appearance and behavior. It is found in the wooded areas of the eastern United States and parts of Mexico, and is known for its bright red plumage, its beautiful, melodic songs, and its fondness for seeds and fruit. In this article, we will explore the fascinating world of the northern cardinal, including its physical characteristics, habitat, diet, behavior, and conservation status.\n\nPhysical Characteristics of Northern Cardinals\n\nNorthern cardinals are medium-sized birds, with a length of about 7.5 to 9 inches and a wingspan of about 10 to 12 inches. They have a distinctive appearance, with a large, round head, a short, thick bill, and a long, pointed tail. They have a bright red plumage, with a red head, neck, and breast, and a red back and wings.\n\nMale and female northern cardinals are similar in appearance, but males have a brighter, more colorful plumage. Juvenile northern cardinals are similar in appearance to adults, but have a more muted, brownish plumage.\n\nNorthern cardinals are known for their beautiful, melodic songs, which include a variety of different whistles, chirps, and trills. They also have a variety of softer, more subdued calls, which they use to communicate with each other.\n\nHabitat and Distribution of Northern Cardinals\n\nNorthern cardinals are found in the wooded areas of the eastern United States and parts of Mexico, including forests, woodlands, and suburban areas. They are found in a variety of habitats, including deciduous forests, coniferous forests, and mixed forests. They are also found in gardens, parks, and other green spaces.\n\nIn their natural habitat, northern cardinals are found in wooded areas, where they can find food and shelter in the form of seeds, fruit, insects, and other small prey. They are adapted to living in forested environments and are able to thrive in the dense canopy of these habitats. In urban areas, they are often found in gardens, parks, and other green spaces, where they can find food and shelter.\n\nDiet and Feeding Behavior of Northern Cardinals\n\nNorthern cardinals are omnivorous, meaning they eat both plants and animals. Their diet consists of seeds, fruit, insects, and other small prey. They are opportunistic feeders and will eat whatever food is available to them.\n\nNorthern cardinals are active during the day and are often seen foraging for food in gardens, parks, and other green spaces. They are known to feed on a variety of seeds, including sunflower seeds, safflower seeds, and millet seeds. They are also known to feed on fruit, including berries, cherries, and grapes.\n\nBehavior and Communication of Northern Cardinals\n\nNorthern cardinals are social birds and are often seen in pairs or small groups. They are vocal birds and have a variety of different calls and songs, which they use to communicate with each other and to defend their territory.\n\nMale northern cardinals are known for their beautiful, melodic songs, which they use to attract mates and defend their territory. They have a variety of different songs, including a variety of different whistles, chirps, and trills. Female northern cardinals are less vocal and tend to give shorter, softer calls.',
        "duration": "T3M32S",
        "order": 565
    },
    "northern-flicker": {
        "name": "Northern flicker",
        "slug": "northern-flicker",
        "text": 'The northern flicker (Colaptes auratus) is a medium-sized woodpecker with a distinctive appearance and behavior. It is found across much of North America and is a familiar sight in gardens, parks, and wooded areas. In this article, we will explore the fascinating world of the northern flicker, including its physical characteristics, habitat, diet, behavior, and conservation status.\n\nPhysical Characteristics of Northern Flickers\n\nNorthern flickers are medium-sized birds, with a length of about 11 to 13 inches and a wingspan of about 17 to 21 inches. They have a distinctive appearance, with a long, pointed bill, a rounded head, and a long, squared-off tail. They have a brown, black, and white plumage, with a prominent white rump and a black bib on their chest.\n\nMale and female northern flickers are similar in appearance, but males have a red patch on the back of their neck and a red moustache stripe on their face. Juvenile northern flickers are similar in appearance to adults, but have a brown, rather than a black, bib on their chest.\n\nNorthern flickers are known for their distinctive calls, which include a series of loud, resonant "kleer" or "wicka" calls. They also have a variety of softer, more subdued calls, which they use to communicate with each other.\n\nHabitat and Distribution of Northern Flickers\n\nNorthern flickers are found across much of North America, from southern Canada to Mexico. They are most commonly found in wooded areas, including deciduous forests, coniferous forests, and mixed forests. They are also found in gardens, parks, and other urban areas.\n\nIn their natural habitat, northern flickers are often found in wooded areas, where they can find food and shelter. They are adaptable birds and are able to thrive in a wide range of environments. In urban areas, they are often found in gardens, parks, and other green spaces, where they can find food and shelter.\n\nDiet and Feeding Behavior of Northern Flickers\n\nNorthern flickers are omnivorous, meaning they eat both plants and animals. Their diet consists of insects, fruit, seeds, and occasionally small invertebrates. They are opportunistic feeders and will eat whatever food is available to them.\n\nNorthern flickers are known for their distinctive feeding behavior, which involves drumming on hard surfaces with their beaks to locate insects. They will also feed on insects that they find on the ground, as well as seeds and fruit that they find in trees and bushes.\n\nBehavior and Communication of Northern Flickers\n\nNorthern flickers are social birds and are often seen in pairs or small groups. They are vocal birds and have a variety of different calls and songs, which they use to communicate with each other and to defend their territory.\n\nMale northern flickers are known for their distinctive songs, which they use to attract mates and defend their territory. They have a variety of different songs, including a series of loud, resonant "kleer" or "wicka" calls. Female northern flickers are less vocal and tend to give shorter, softer calls.\n\nNorthern flickers are territorial birds and will defend their territory from other flickers and other birds. They are also known to be aggressive towards other birds at feeding stations, and will often dominate and exclude other species from feeding areas.\n\nConservation Status\n\nThe northern flicker is classified as a species of "Least Concern" by the International Union for Conservation of Nature (IUCN).',
        "duration": "T16S",
        "order": 577
    },
    "northern-fulmar": {
        "name": "Northern fulmar",
        "slug": "northern-fulmar",
        "text": "",
        "duration": "T1M8S",
        "order": 185
    },
    "northern-gannet": {
        "name": "Northern gannet",
        "slug": "northern-gannet",
        "text": "",
        "duration": "T31S",
        "order": 413
    },
    "northern-goshawk": {
        "name": "Northern goshawk",
        "slug": "northern-goshawk",
        "text": "",
        "duration": "T1M28S",
        "order": 508
    },
    "northern-harrier": {
        "name": "Northern harrier",
        "slug": "northern-harrier",
        "text": "",
        "duration": "T32S",
        "order": 518
    },
    "northern-hawk-owl": {
        "name": "Northern hawk-owl",
        "slug": "northern-hawk-owl",
        "text": "",
        "duration": "T20S",
        "order": 327
    },
    "northern-mockingbird": {
        "name": "Northern mockingbird",
        "slug": "northern-mockingbird",
        "text": "",
        "duration": "T1M20S",
        "order": 517
    },
    "northern-parula": {
        "name": "Northern parula",
        "slug": "northern-parula",
        "text": "",
        "duration": "T54S",
        "order": 341
    },
    "northern-pintail": {
        "name": "Northern pintail",
        "slug": "northern-pintail",
        "text": "",
        "duration": "T31S",
        "order": 444
    },
    "northern-pygmy-owl": {
        "name": "Northern pygmy owl",
        "slug": "northern-pygmy-owl",
        "text": "",
        "duration": "T1M5S",
        "order": 318
    },
    "northern-rough-winged-swallow": {
        "name": "Northern rough-winged swallow",
        "slug": "northern-rough-winged-swallow",
        "text": "",
        "duration": "T37S",
        "order": 67
    },
    "northern-saw-whet-owl": {
        "name": "Northern saw-whet owl",
        "slug": "northern-saw-whet-owl",
        "text": "",
        "duration": "T16S",
        "order": 462
    },
    "northern-shoveler": {
        "name": "Northern shoveler",
        "slug": "northern-shoveler",
        "text": "",
        "duration": "T13S",
        "order": 448
    },
    "northern-waterthrush": {
        "name": "Northern waterthrush",
        "slug": "northern-waterthrush",
        "text": "",
        "duration": "T40S",
        "order": 141
    },
    "northern-wheatear": {
        "name": "Northern Wheatear",
        "slug": "northern-wheatear",
        "text": "",
        "duration": "T5M45S",
        "order": 232
    },
    "northwestern-crow": {
        "name": "Northwestern crow",
        "slug": "northwestern-crow",
        "text": "",
        "duration": "T1M0S",
        "order": 71
    },
    "nuttalls-woodpecker": {
        "name": "Nuttall's woodpecker",
        "slug": "nuttalls-woodpecker",
        "text": "",
        "duration": "T1M32S",
        "order": 194
    },
    "oak-titmouse": {
        "name": "Oak titmouse",
        "slug": "oak-titmouse",
        "text": "",
        "duration": "T49S",
        "order": 171
    },
    "olive-sided-flycatcher": {
        "name": "Olive-sided flycatcher",
        "slug": "olive-sided-flycatcher",
        "text": "",
        "duration": "T32S",
        "order": 184
    },
    "orange-crowned-warbler": {
        "name": "Orange-crowned warbler",
        "slug": "orange-crowned-warbler",
        "text": "",
        "duration": "T1M28S",
        "order": 373
    },
    "orchard-oriole": {
        "name": "Orchard oriole",
        "slug": "orchard-oriole",
        "text": "",
        "duration": "T25S",
        "order": 225
    },
    "osprey": {
        "name": "Osprey",
        "slug": "osprey",
        "text": "Ominous to fish and glorious to the eye, Osprey is a unique white hawk with brown wings. Ospreys nest on trees and feed on fish in rivers. Hence, their other names are river hawk, sea hawk, and fish hawk.\n" +
            "They usually venture on shorelines and waterways looking for the perfect prey. Then they dive into the water with outstretched feet to catch a live fish. Like most of their peers, Ospreys reside in North America and migrate south during cold seasons.\n" +
            "During the 15 to 20 years they live, Ospreys fly more than 160,000 miles to migrate to more pleasant homes. Once they’re 3 or 4 years old, they begin looking for a mate.\n" +
            "They usually breed in September–October and lay 2 to 4 eggs each time. Ospreys can fly up to 80 miles per hour (128 km/h). If you’re ever near open waters filled with fish, listen for chirping or whistling sounds. You might find an Osprey zooming above you like a giant bullet in the sky.",
        "duration": "T27S",
        "order": 597
    },
    "ovenbird": {
        "name": "Ovenbird",
        "slug": "ovenbird",
        "text": "",
        "duration": "T1M58S",
        "order": 488
    },
    "pacific-golden-plover": {
        "name": "Pacific golden plover",
        "slug": "pacific-golden-plover",
        "text": "",
        "duration": "T6S",
        "order": 278
    },
    "pacific-loon": {
        "name": "Pacific loon",
        "slug": "pacific-loon",
        "text": "",
        "duration": "T30S",
        "order": 193
    },
    "pacific-wren": {
        "name": "Pacific wren",
        "slug": "pacific-wren",
        "text": "",
        "duration": "T1M50S",
        "order": 132
    },
    "pacific-slope-flycatcher": {
        "name": "Pacific-slope flycatcher",
        "slug": "pacific-slope-flycatcher",
        "text": "",
        "duration": "T1M14S",
        "order": 75
    },
    "painted-bunting": {
        "name": "Painted bunting",
        "slug": "painted-bunting",
        "text": "",
        "duration": "T1M25S",
        "order": 516
    },
    "painted-redstart": {
        "name": "Painted redstart",
        "slug": "painted-redstart",
        "text": "",
        "duration": "T41S",
        "order": 56
    },
    "palm-warbler": {
        "name": "Palm warbler",
        "slug": "palm-warbler",
        "text": "",
        "duration": "T1M18S",
        "order": 405
    },
    "parasitic-jaeger": {
        "name": "Parasitic jaeger",
        "slug": "parasitic-jaeger",
        "text": "",
        "duration": "T24S",
        "order": 351
    },
    "pectoral-sandpiper": {
        "name": "Pectoral sandpiper",
        "slug": "pectoral-sandpiper",
        "text": "",
        "duration": "T5S",
        "order": 337
    },
    "pelagic-cormorant": {
        "name": "Pelagic cormorant",
        "slug": "pelagic-cormorant",
        "text": "",
        "duration": "T4M35S",
        "order": 140
    },
    "peregrine-falcon": {
        "name": "Peregrine falcon",
        "slug": "peregrine-falcon",
        "text": "Next time you’re walking in the city, watch out for tall structures such as power pylons, water towers, skyscrapers, and cliffs. You might find a Peregrine falcon perching there and gazing at you. It’s common to find Peregrine falcons anywhere in North America, but they’re mostly found along coasts. Having an average length of 14.2-19.3 in (36-49 cm) and weighing around 18.7-56.4 oz (530-1600 g), these falcons are the largest falcons in most of the continent.\n" +
            "Peregrines are distinctive and memorable for their aesthetically pleasing color pattern. Having an eye-catching blue-gray body that darkens as it moves toward the head contrasts with its white breast and yellow bills and feet. This makes Peregrines an element of beauty in nature and awe-inspiring for other birds.\n" +
            "Peregrines usually lay 3 to 4 eggs. The female falcon looks after the offspring, while the male provides the nest with food. Peregrines are swift and skillful hunters. In cities, you’ll find them making swift dives which are called stoops, to catch pigeons. In nature, however, they seek ducks and shorebirds as their prey.\n" +
            "These falcons are one of the world’s fastest birds, potentially reaching 200 mph while diving.\n",
        "duration": "T2M39S",
        "order": 592
    },
    "philadelphia-vireo": {
        "name": "Philadelphia vireo",
        "slug": "philadelphia-vireo",
        "text": "",
        "duration": "T1M4S",
        "order": 218
    },
    "pied-billed-grebe": {
        "name": "Pied-billed grebe",
        "slug": "pied-billed-grebe",
        "text": "",
        "duration": "T7M28S",
        "order": 412
    },
    "pigeon-guillemot": {
        "name": "Pigeon guillemot",
        "slug": "pigeon-guillemot",
        "text": "",
        "duration": "T55S",
        "order": 117
    },
    "pileated-woodpecker": {
        "name": "Pileated woodpecker",
        "slug": "pileated-woodpecker",
        "text": "With their mohawk red hair and wood stabbing habit, Pileated woodpeckers are easily recognizable to anyone. Woodpeckers are about the size of a crow and they’re considered the largest forest birds on the continent. They are 16-19.5” in length and weigh around 8.8-16 ounces.\n" +
            "They have a black body with a few major white stripes, but their most noticeable feature is their flaming-red crest.\n" +
            "The male also has a red mustache which helps them become distinguishable from the female.\n" +
            "These birds spend most of their day making rectangular holes in trees to look for insects to eat. These holes later serve a different purpose as ducks, bats, swifts, and owls use them as shelter. So as you can expect, Pileated woodpeckers can mostly be found in mature forests that offer an abundance of dead trees and downed logs.\n" +
            "These exotic birds can mostly be found in eastern North America, the boreal forests of Canada, parts of the Pacific Coast, and the Great Lakes. Woodpeckers are territorial, but they can show compassion to immigrants as well.\n" +
            "Pileated woodpecker pairs stay together and defend their territories all year. However, during the cold winter days, they may allow new arrivals.",
        "duration": "T21S",
        "order": 581
    },
    "pine-grosbeak": {
        "name": "Pine grosbeak",
        "slug": "pine-grosbeak",
        "text": "",
        "duration": "T32S",
        "order": 357
    },
    "pine-siskin": {
        "name": "Pine siskin",
        "slug": "pine-siskin",
        "text": "",
        "duration": "T24S",
        "order": 469
    },
    "pine-warbler": {
        "name": "Pine warbler",
        "slug": "pine-warbler",
        "text": "",
        "duration": "T2M2S",
        "order": 460
    },
    "pinyon-jay": {
        "name": "Pinyon jay",
        "slug": "pinyon-jay",
        "text": "",
        "duration": "T1M15S",
        "order": 231
    },
    "piping-plover": {
        "name": "Piping plover",
        "slug": "piping-plover",
        "text": "",
        "duration": "T20S",
        "order": 523
    },
    "plumbeous-vireo": {
        "name": "Plumbeous vireo",
        "slug": "plumbeous-vireo",
        "text": "",
        "duration": "T19S",
        "order": 29
    },
    "prairie-falcon": {
        "name": "Prairie falcon",
        "slug": "prairie-falcon",
        "text": "",
        "duration": "T24S",
        "order": 426
    },
    "prairie-warbler": {
        "name": "Prairie warbler",
        "slug": "prairie-warbler",
        "text": "",
        "duration": "T40S",
        "order": 183
    },
    "prothonotary-warbler": {
        "name": "Prothonotary warbler",
        "slug": "prothonotary-warbler",
        "text": "",
        "duration": "T1M55S",
        "order": 288
    },
    "purple-finch": {
        "name": "Purple finch",
        "slug": "purple-finch",
        "text": "",
        "duration": "T2M21S",
        "order": 490
    },
    "purple-gallinule": {
        "name": "Purple gallinule",
        "slug": "purple-gallinule",
        "text": "",
        "duration": "T53S",
        "order": 326
    },
    "purple-martin": {
        "name": "Purple martin",
        "slug": "purple-martin",
        "text": "",
        "duration": "T33S",
        "order": 526
    },
    "purple-sandpiper": {
        "name": "Purple sandpiper",
        "slug": "purple-sandpiper",
        "text": "",
        "duration": "T9S",
        "order": 425
    },
    "pygmy-nuthatch": {
        "name": "Pygmy nuthatch",
        "slug": "pygmy-nuthatch",
        "text": "",
        "duration": "T19S",
        "order": 192
    },
    "pyrrhuloxia": {
        "name": "Pyrrhuloxia",
        "slug": "pyrrhuloxia",
        "text": "",
        "duration": "T43S",
        "order": 259
    },
    "razorbill": {
        "name": "Razorbill",
        "slug": "razorbill",
        "text": "",
        "duration": "T11S",
        "order": 478
    },
    "red-crossbill": {
        "name": "Red crossbill",
        "slug": "red-crossbill",
        "text": "",
        "duration": "T1M12S",
        "order": 246
    },
    "red-knot": {
        "name": "Red knot",
        "slug": "red-knot",
        "text": "",
        "duration": "T28S",
        "order": 411
    },
    "red-bellied-woodpecker": {
        "name": "Red-bellied woodpecker",
        "slug": "red-bellied-woodpecker",
        "text": 'The red-bellied woodpecker (Melanerpes carolinus) is a medium-sized bird with a distinctive appearance and behavior. It is found in a wide range of habitats across much of the eastern United States and parts of Canada, and is known for its striking plumage, its distinctive calls, and its fondness for insects and other small prey. In this article, we will explore the fascinating world of the red-bellied woodpecker, including its physical characteristics, habitat, diet, behavior, and conservation status.\n\nPhysical Characteristics of Red-bellied Woodpeckers\n\nRed-bellied woodpeckers are medium-sized birds, with a length of about 9 to 11 inches and a wingspan of about 13 to 15 inches. They have a distinctive appearance, with a large, round head, a long, pointed beak, and a long, pointed tail. They have a striking plumage, with a black and white barred back and wings, and a bright red head and belly, which gives them their name.\n\nMale and female red-bellied woodpeckers are similar in appearance, but males have a brighter, more colorful plumage. Juvenile red-bellied woodpeckers are similar in appearance to adults, but have a more muted, brownish plumage.\n\nRed-bellied woodpeckers are known for their distinctive calls, which include a series of loud, harsh "churr" and "churr" sounds. They also have a variety of softer, more subdued calls, which they use to communicate with each other.\n\nHabitat and Distribution of Red-bellied Woodpeckers\n\nRed-bellied woodpeckers are found in a wide range of habitats across much of the eastern United States and parts of Canada, including forests, woodlands, grasslands, and urban areas. They are found in a variety of habitats, including deciduous forests, coniferous forests, and mixed forests. They are also found in gardens, parks, and other green spaces.\n\nIn their natural habitat, red-bellied woodpeckers are found in wooded areas, where they can find food and shelter in the form of insects, worms, and other small prey. They are adapted to living in forested environments and are able to thrive in the dense canopy of these habitats. In urban areas, they are often found in gardens, parks, and other green spaces, where they can find food and shelter.\n\nDiet and Feeding Behavior of Red-bellied Woodpeckers\n\nRed-bellied woodpeckers are omnivorous, meaning they eat both plants and animals. Their diet consists of insects, worms, fruit, and other small prey. They are opportunistic feeders and will eat whatever food is available to them.\n\nRed-bellied woodpeckers are active during the day and are often seen foraging for food in trees, bushes, and other wooded areas. They are known to feed on a variety of insects, including beetles, ants, and grasshoppers, as well as worms and other small prey. They are also known to feed on fruit, including berries, cherries, and grapes.',
        "duration": "T1M7S",
        "order": 556
    },
    "red-billed-tropicbird": {
        "name": "Red-billed tropicbird",
        "slug": "red-billed-tropicbird",
        "text": "",
        "duration": "T37S",
        "order": 95
    },
    "red-breasted-merganser": {
        "name": "Red-breasted merganser",
        "slug": "red-breasted-merganser",
        "text": "",
        "duration": "T32S",
        "order": 416
    },
    "red-breasted-nuthatch": {
        "name": "Red-breasted nuthatch",
        "slug": "red-breasted-nuthatch",
        "text": "",
        "duration": "T2M57S",
        "order": 468
    },
    "red-breasted-sapsucker": {
        "name": "Red-breasted sapsucker",
        "slug": "red-breasted-sapsucker",
        "text": "",
        "duration": "T29S",
        "order": 217
    },
    "red-cockaded-woodpecker": {
        "name": "Red-cockaded woodpecker",
        "slug": "red-cockaded-woodpecker",
        "text": "",
        "duration": "T47S",
        "order": 401
    },
    "red-crowned-parrot": {
        "name": "Red-crowned parrot",
        "slug": "red-crowned-parrot",
        "text": "",
        "duration": "T42S",
        "order": 160
    },
    "red-eyed-vireo": {
        "name": "Red-eyed vireo",
        "slug": "red-eyed-vireo",
        "text": "",
        "duration": "T58S",
        "order": 393
    },
    "red-faced-warbler": {
        "name": "Red-faced warbler",
        "slug": "red-faced-warbler",
        "text": "",
        "duration": "T20S",
        "order": 35
    },
    "red-footed-booby": {
        "name": "Red-footed booby",
        "slug": "red-footed-booby",
        "text": "",
        "duration": "T2M44S",
        "order": 443
    },
    "redhead": {
        "name": "Redhead",
        "slug": "redhead",
        "text": "If you want to spot a Redhead bird, you notice as its name suggests. This bird is identified by its cinnamon red head. However, the rest of his body is not red. Its tail and neck are black and weave into a spectrum of gray.\n" +
            "As a North American diving duck, Redheads can be found in seasonal wetlands including the prairie pothole region of the Midwest. During winter, they migrate and live serenely as flocks on lakes and bays. During migration season, Redheads are seen flying with other species such as scaup, American Coots, and Canvasbacks. Having a length of 16.5-21.3 in (42-54 cm) and a weight of 22.2-52.9 oz (630-1500 g), Redheads are somewhat small.\n" +
            "They usually dive into shallow waters to look for insects and plants. Although when they move south, their diet is prone to vegetarian food sources. They even choose dense marshes to build a nest and grow their families. Redheads live peacefully without having many predators.\n" +
            "If a Redhead dies, it’s probably because of a disease. Having this detachment from the wild has given Redheads a serene quality that makes natural scenery more peaceful and pleasant.",
        "duration": "T11S",
        "order": 594
    },
    "red-headed-woodpecker": {
        "name": "Red-headed woodpecker",
        "slug": "red-headed-woodpecker",
        "text": 'The red-headed woodpecker (Melanerpes erythrocephalus) is a medium-sized woodpecker with a distinctive appearance and behavior. It is found in a wide range of habitats across much of the eastern United States and parts of Canada, and is known for its bright red head, its striking black-and-white pattern, and its fondness for insects and other small prey. In this article, we will explore the fascinating world of the red-headed woodpecker, including its physical characteristics, habitat, diet, behavior, and conservation status.\n\nPhysical Characteristics of Red-headed Woodpeckers\n\nRed-headed woodpeckers are medium-sized birds, with a length of about 8 to 9.5 inches and a wingspan of about 13 to 16 inches. They have a distinctive appearance, with a large, round head, a short, thick bill, and a long, pointed tail. They have a bright red head, a black back and wings, and a white breast.\n\nMale and female red-headed woodpeckers are similar in appearance, but males have a brighter, more colorful plumage. Juvenile red-headed woodpeckers are similar in appearance to adults, but have a more muted, brownish plumage.\n\nRed-headed woodpeckers are known for their distinctive calls, which include a series of sharp, piercing "churrs" and "churrs." They also have a variety of softer, more subdued calls, which they use to communicate with each other.\n\nHabitat and Distribution of Red-headed Woodpeckers\n\nRed-headed woodpeckers are found in a wide range of habitats across much of the eastern United States and parts of Canada, including forests, woodlands, grasslands, and urban areas. They are found in a variety of habitats, including deciduous forests, coniferous forests, and mixed forests. They are also found in gardens, parks, and other green spaces.\n\nIn their natural habitat, red-headed woodpeckers are found in wooded areas, where they can find food and shelter in the form of insects, worms, and other small prey. They are adapted to living in forested environments and are able to thrive in the dense canopy of these habitats. In urban areas, they are often found in gardens, parks, and other green spaces, where they can find food and shelter.\n\nDiet and Feeding Behavior of Red-headed Woodpeckers\n\nRed-headed woodpeckers are carnivorous, meaning they eat animals. Their diet consists of insects, worms, and other small prey. They are opportunistic feeders and will eat whatever prey is available to them.\n\nRed-headed woodpeckers are active during the day and are often seen foraging for food in trees, bushes, and other wooded areas. They are known to feed on a variety of insects, including beetles, ants, and grasshoppers, as well as worms and other small prey. They are also known to feed on fruit, including berries, cherries, and grapes.',
        "duration": "T1M8S",
        "order": 563
    },
    "red-naped-sapsucker": {
        "name": "Red-naped sapsucker",
        "slug": "red-naped-sapsucker",
        "text": "",
        "duration": "T1M5S",
        "order": 159
    },
    "red-necked-grebe": {
        "name": "Red-necked grebe",
        "slug": "red-necked-grebe",
        "text": "",
        "duration": "T11S",
        "order": 245
    },
    "red-necked-phalarope": {
        "name": "Red-necked phalarope",
        "slug": "red-necked-phalarope",
        "text": "",
        "duration": "T15S",
        "order": 208
    },
    "red-shouldered-hawk": {
        "name": "Red-shouldered hawk",
        "slug": "red-shouldered-hawk",
        "text": 'The red-shouldered hawk (Buteo lineatus) is a medium-sized bird of prey with a distinctive appearance and behavior. It is found in the forests, swamps, and other wooded habitats of eastern North America, and is known for its reddish-brown and white plumage, its loud, harsh calls, and its acrobatic hunting style. In this article, we will explore the fascinating world of the red-shouldered hawk, including its physical characteristics, habitat, diet, behavior, and conservation status.\n\nPhysical Characteristics of Red-shouldered Hawks\n\nRed-shouldered hawks are medium-sized birds, with a length of about 16 to 24 inches and a wingspan of about 37 to 43 inches. They have a distinctive appearance, with a large, rounded head, a long, narrow tail, and long, powerful wings. They have a reddish-brown and white plumage, with a reddish-brown head, neck, and breast, and a white belly and tail.\n\nMale and female red-shouldered hawks are similar in appearance, but males are slightly smaller. Juvenile red-shouldered hawks are similar in appearance to adults, but have a brown, rather than a reddish-brown, plumage.\n\nRed-shouldered hawks are known for their distinctive calls, which include a series of loud, harsh "kee-ah" calls. They also have a variety of softer, more subdued calls, which they use to communicate with each other.\n\nHabitat and Distribution of Red-shouldered Hawks\n\nRed-shouldered hawks are found in the forests, swamps, and other wooded habitats of eastern North America, including the southeastern United States, the eastern Great Lakes region, and the Appalachian Mountains. They are found in a variety of habitats, including deciduous forests, mixed forests, and swamps. They are also found in gardens, parks, and other urban areas.\n\nIn their natural habitat, red-shouldered hawks are found in wooded areas, where they can find food and shelter in the form of small mammals, birds, reptiles, and insects. They are adapted to living in forested environments and are able to thrive in the dense canopy of these habitats. In urban areas, they are often found in gardens, parks, and other green spaces, where they can find food and shelter.\n\nDiet and Feeding Behavior of Red-shouldered Hawks\n\nRed-shouldered hawks are carnivorous, meaning they eat animals. Their diet consists of small mammals, birds, reptiles, and insects. They are opportunistic feeders and will eat whatever food is available to them.\n\nRed-shouldered hawks are active during the day and at night, and will hunt for food at any time. They are known to hunt from the air, using their keen eyesight to locate prey. They are also known to hunt from perches, where they wait patiently for prey to come within range.\n\nBehavior and Communication of Red-shouldered Hawks\n\nRed-shouldered hawks are social birds and are often seen in pairs or small groups. They are vocal birds and have a variety of different calls and songs, which they use to communicate with each other and to defend their territory.\n\nMale red-shouldered hawks are known for their distinctive songs, which they use to attract mates and defend their territory.',
        "duration": "T34S",
        "order": 568
    },
    "red-tailed-hawk": {
        "name": "Red-tailed hawk",
        "slug": "red-tailed-hawk",
        "text": "A Red-tailed hawk gives away his appearance by his name. These birds are distinguishable by their pale cinnamon color. The rest of their body, however, is a rich brown color that dissolves into the black tip of their feathers. Meanwhile, if you look at this bird from below, you'll see a streaked color pattern that’s mostly pale, and his below outline has the same color as his above. As the second-largest Buteo hawk in North America, these birds love the open country. You’ll find them perched on fence posts, telephone poles, and along with the fields like a watchful statue. They live about 10-15 years, feeding on small mammals, reptiles, and birds.\n" +
            "These hawks have a hunting style much different from the falcon’s stoop. Red-tailed hawks hunt with peace of mind. They usually move in circles in the air, occasionally flapping a heavy wing with never blinking eyes that endlessly watch the ground. When attacking time comes, they stretch their legs and make a slow and controlled dive.\n" +
            "You can find these hawks throughout most parts of North America. They can be anywhere as far north as northern Canada and Alaska, or as far south as the West Indies and Panama.",
        "duration": "T31S",
        "order": 590
    },
    "red-tailed-tropicbird": {
        "name": "Red-tailed tropicbird",
        "slug": "red-tailed-tropicbird",
        "text": "",
        "duration": "T1M3S",
        "order": 94
    },
    "red-throated-loon": {
        "name": "Red-throated loon",
        "slug": "red-throated-loon",
        "text": "",
        "duration": "T49S",
        "order": 207
    },
    "red-throated-pipit": {
        "name": "Red-throated pipit",
        "slug": "red-throated-pipit",
        "text": "",
        "duration": "T1M7S",
        "order": 62
    },
    "red-winged-blackbird": {
        "name": "Red-winged blackbird",
        "slug": "red-winged-blackbird",
        "text": "",
        "duration": "T56S",
        "order": 538
    },
    "ridgways-rail": {
        "name": "Ridgway's rail",
        "slug": "ridgways-rail",
        "text": "",
        "duration": "T53S",
        "order": 63
    },
    "ring-billed-gull": {
        "name": "Ring-billed gull",
        "slug": "ring-billed-gull",
        "text": "",
        "duration": "T17S",
        "order": 424
    },
    "ringed-kingfisher": {
        "name": "Ringed kingfisher",
        "slug": "ringed-kingfisher",
        "text": "",
        "duration": "T57S",
        "order": 93
    },
    "ring-necked-duck": {
        "name": "Ring-necked duck",
        "slug": "ring-necked-duck",
        "text": "",
        "duration": "T10S",
        "order": 495
    },
    "ring-necked-pheasant": {
        "name": "Ring-necked pheasant",
        "slug": "ring-necked-pheasant",
        "text": 'The ring-necked pheasant (Phasianus colchicus) is a large, colorful bird with a distinctive appearance and behavior. It is found in a wide range of habitats across much of the United States and Canada, and is known for its striking plumage, its loud, distinctive calls, and its fondness for seeds and insects. In this article, we will explore the fascinating world of the ring-necked pheasant, including its physical characteristics, habitat, diet, behavior, and conservation status.\n\nPhysical Characteristics of Ring-necked Pheasants\n\nRing-necked pheasants are large birds, with a length of about 29 to 32 inches and a wingspan of about 40 to 45 inches. They have a distinctive appearance, with a long, pointed tail, a long, thin neck, and a large, round body. They have a striking plumage, with a green head, a golden neck, and a red, orange, and yellow body.\n\nMale and female ring-necked pheasants are quite different in appearance. Males have a more colorful and striking plumage, with a green head, a golden neck, and a red, orange, and yellow body. Females are more subdued in color, with a brown head, neck, and body. Juvenile ring-necked pheasants are similar in appearance to females, but have a more mottled, speckled plumage.\n\nRing-necked pheasants are known for their loud, distinctive calls, which include a variety of different cackles, crows, and coos. They also have a variety of softer, more subdued calls, which they use to communicate with each other.\n\nHabitat and Distribution of Ring-necked Pheasants\n\nRing-necked pheasants are found in a wide range of habitats across much of the United States and Canada, including forests, grasslands, and agricultural areas. They are found in a variety of habitats, including deciduous forests, coniferous forests, and mixed forests. They are also found in gardens, parks, and other green spaces.\n\nIn their natural habitat, ring-necked pheasants are found in wooded areas and grasslands, where they can find food and shelter in the form of seeds, insects, and other small prey. They are adapted to living in open, grassy environments and are able to thrive in the dense canopy of these habitats. In urban areas, they are often found in gardens, parks, and other green spaces, where they can find food and shelter.\n\nDiet and Feeding Behavior of Ring-necked Pheasants\n\nRing-necked pheasants are omnivorous, meaning they eat both plants and animals. Their diet consists of seeds, insects, and other small prey. They are opportunistic feeders and will eat whatever food is available to them.\n\nRing-necked pheasants are active during the day and are often seen foraging for food in gardens, parks, and other green spaces. They are known to feed on a variety of seeds, including sunflower seeds, safflower seeds, and millet seeds. They are also known to feed on insects, including beetles, ants, and grasshoppers.',
        "duration": "T9S",
        "order": 562
    },
    "rock-dove": {
        "name": "Rock dove",
        "slug": "rock-dove",
        "text": 'The rock dove (Columba livia), also known as the pigeon, is a medium-sized bird with a distinctive appearance and behavior. It is found in a wide variety of habitats across much of the world, and is one of the most common and widespread birds on the planet. In this article, we will explore the fascinating world of the rock dove, including its physical characteristics, habitat, diet, behavior, and conservation status.\n\nPhysical Characteristics of Rock Doves\n\nRock doves are medium-sized birds, with a length of about 12 to 14 inches and a wingspan of about 20 to 24 inches. They have a distinctive appearance, with a plump body, a small, conical bill, and a short, squared-off tail. They have a grey and white plumage, with a pale grey head, neck, and breast, and a darker grey back and wings.\n\nMale and female rock doves are similar in appearance, but males are slightly larger and have a more colorful plumage. Juvenile rock doves are similar in appearance to adults, but have a brown, rather than a grey, plumage.\n\nRock doves are known for their distinctive cooing calls, which include a series of soft, low-pitched "coo" calls. They also have a variety of softer, more subdued calls, which they use to communicate with each other.\n\nHabitat and Distribution of Rock Doves\n\nRock doves are found in a wide variety of habitats across much of the world, including urban areas, gardens, parks, and agricultural areas. They are native to Europe, Asia, and Africa, but have been introduced to many other parts of the world, including North and South America, Australia, and New Zealand.\n\nIn their native range, rock doves are found in a variety of habitats, including forests, grasslands, and agricultural areas. They are adaptable birds and are able to thrive in a wide range of environments. In non-native areas, they are often found in urban environments, where they can find food and shelter in the form of bird feeders, gardens, and buildings.\n\nDiet and Feeding Behavior of Rock Doves\n\nRock doves are omnivorous, meaning they eat both plants and animals. Their diet consists of seeds, grains, fruit, insects, and occasionally small invertebrates. They are opportunistic feeders and will eat whatever food is available to them.\n\nRock doves are social birds and often feed in flocks. They are commonly seen at bird feeders, where they will feed on seeds and grains. They are also known to scavenge for food in gardens and parks, and will often feed on the seeds and fruits of various plants.\n\nBehavior and Communication of Rock Doves\n\nRock doves are highly social birds and are often seen in flocks. They are vocal birds and have a variety of different calls and songs, which they use to communicate with each other and to defend their territory.\n\nMale rock doves are known for their distinctive cooing songs, which they use to attract mates and defend their territory. They have a variety of different songs, including a series of soft, low-pitched "coo" calls. Female rock doves are less vocal and tend to give shorter, softer calls.\n\nRock doves are territorial birds and will defend their territory from other doves and other birds. They are also known to be aggressive towards other birds at feeding stations, and will often dominate and exclude other species from feeding areas.',
        "duration": "T13S",
        "order": 574
    },
    "rock-sandpiper": {
        "name": "Rock sandpiper",
        "slug": "rock-sandpiper",
        "text": "",
        "duration": "T37S",
        "order": 17
    },
    "rock-wren": {
        "name": "Rock wren",
        "slug": "rock-wren",
        "text": "",
        "duration": "T38S",
        "order": 170
    },
    "roseate-spoonbill": {
        "name": "Roseate spoonbill",
        "slug": "roseate-spoonbill",
        "text": "",
        "duration": "T1M12S",
        "order": 534
    },
    "roseate-tern": {
        "name": "Roseate tern",
        "slug": "roseate-tern",
        "text": "",
        "duration": "T9S",
        "order": 206
    },
    "rose-breasted-grosbeak": {
        "name": "Rose-breasted grosbeak",
        "slug": "rose-breasted-grosbeak",
        "text": "",
        "duration": "T56S",
        "order": 433
    },
    "rosss-goose": {
        "name": "Ross's goose",
        "slug": "rosss-goose",
        "text": "",
        "duration": "T45S",
        "order": 395
    },
    "rough-legged-hawk": {
        "name": "Rough-legged hawk",
        "slug": "rough-legged-hawk",
        "text": "",
        "duration": "T1M17S",
        "order": 439
    },
    "royal-tern": {
        "name": "Royal tern",
        "slug": "royal-tern",
        "text": "",
        "duration": "T27S",
        "order": 455
    },
    "ruby-crowned-kinglet": {
        "name": "Ruby-crowned kinglet",
        "slug": "ruby-crowned-kinglet",
        "text": "",
        "duration": "T26S",
        "order": 483
    },
    "ruby-throated-hummingbird": {
        "name": "Ruby-throated hummingbird",
        "slug": "ruby-throated-hummingbird",
        "text": 'The ruby-throated hummingbird (Archilochus colubris) is a small, colorful bird with a distinctive appearance and behavior. It is found in a wide range of habitats across much of the eastern United States and parts of Mexico, and is known for its striking plumage, its ability to hover, and its fondness for nectar. In this article, we will explore the fascinating world of the ruby-throated hummingbird, including its physical characteristics, habitat, diet, behavior, and conservation status.\n\nPhysical Characteristics of Ruby-throated Hummingbirds\n\nRuby-throated hummingbirds are small birds, with a length of about 3 to 4 inches and a wingspan of about 4 to 5 inches. They have a distinctive appearance, with a small, round head, a short, thin bill, and a long, pointed tail. They have a striking plumage, with a metallic green back and wings, and a bright red throat, which gives them their name.\n\nMale and female ruby-throated hummingbirds are similar in appearance, but males have a brighter, more colorful plumage. Juvenile ruby-throated hummingbirds are similar in appearance to adults, but have a more muted, brownish plumage.\n\nRuby-throated hummingbirds are known for their distinctive calls, which include a series of soft, high-pitched "chip" and "chip" sounds. They also have a variety of softer, more subdued calls, which they use to communicate with each other.\n\nHabitat and Distribution of Ruby-throated Hummingbirds\n\nRuby-throated hummingbirds are found in a wide range of habitats across much of the eastern United States and parts of Mexico, including forests, woodlands, grasslands, and urban areas. They are found in a variety of habitats, including deciduous forests, coniferous forests, and mixed forests. They are also found in gardens, parks, and other green spaces.\n\nIn their natural habitat, ruby-throated hummingbirds are found in wooded areas, where they can find food and shelter in the form of nectar and insects. They are adapted to living in forested environments and are able to thrive in the dense canopy of these habitats. In urban areas, they are often found in gardens, parks, and other green spaces, where they can find food and shelter.\n\nDiet and Feeding Behavior of Ruby-throated Hummingbirds\n\nRuby-throated hummingbirds are nectarivorous, meaning they feed on nectar from flowers. They are also known to feed on insects and other small prey. They are opportunistic feeders and will eat whatever food is available to them.\n\nRuby-throated hummingbirds are active during the day and are often seen foraging for food in trees, bushes, and other wooded areas. They are known to feed on nectar from a variety of flowers, including trumpet vine, cardinal flower, and bee balm. They are also known to feed on insects, including beetles, ants, and grasshoppers.\n\nBehavior and Communication of Ruby-throated Hummingbirds\n\nRuby-throated hummingbirds are solitary birds and are often seen alone or in pairs. They are vocal birds and have a variety of different calls and songs, which they use to communicate with each other',
        "duration": "T27S",
        "order": 557
    },
    "ruddy-duck": {
        "name": "Ruddy duck",
        "slug": "ruddy-duck",
        "text": "",
        "duration": "T18S",
        "order": 531
    },
    "ruddy-turnstone": {
        "name": "Ruddy turnstone",
        "slug": "ruddy-turnstone",
        "text": "",
        "duration": "T18S",
        "order": 360
    },
    "ruffed-grouse": {
        "name": "Ruffed grouse",
        "slug": "ruffed-grouse",
        "text": 'The ruffed grouse (Bonasa umbellus) is a medium-sized bird with a distinctive appearance and behavior. It is found across much of North America, particularly in the forested areas of the northern United States and Canada. In this article, we will explore the fascinating world of the ruffed grouse, including its physical characteristics, habitat, diet, behavior, and conservation status.\n\nPhysical Characteristics of Ruffed Grouse\n\nRuffed grouse are medium-sized birds, with a length of about 16 to 20 inches and a wingspan of about 24 to 28 inches. They have a distinctive appearance, with a plump body, a small, conical bill, and a short, squared-off tail. They have a brown and grey plumage, with a grey head, neck, and breast, and a brown back and wings.\n\nMale and female ruffed grouse are similar in appearance, but males have a larger, more colorful neck ruff, which gives them their name. Juvenile ruffed grouse are similar in appearance to adults, but have a brown, rather than a grey, head and neck.\n\nRuffed grouse are known for their distinctive drumming calls, which they make by beating their wings against the air to create a loud, rhythmic sound. They also have a variety of softer, more subdued calls, which they use to communicate with each other.\n\nHabitat and Distribution of Ruffed Grouse\n\nRuffed grouse are found across much of North America, particularly in the forested areas of the northern United States and Canada. They are found in a variety of habitats, including deciduous forests, coniferous forests, and mixed forests. They are also found in gardens, parks, and other urban areas.\n\nIn their natural habitat, ruffed grouse are often found in wooded areas, where they can find food and shelter. They are adaptable birds and are able to thrive in a wide range of environments. In urban areas, they are often found in gardens, parks, and other green spaces, where they can find food and shelter.\n\nDiet and Feeding Behavior of Ruffed Grouse\n\nRuffed grouse are omnivorous, meaning they eat both plants and animals. Their diet consists of insects, fruit, seeds, and occasionally small invertebrates. They are opportunistic feeders and will eat whatever food is available to them.\n\nRuffed grouse are known for their distinctive feeding behavior, which involves foraging on the ground for food. They will also feed on insects that they find on the ground, as well as seeds and fruit that they find in trees and bushes.\n\nBehavior and Communication of Ruffed Grouse\n\nRuffed grouse are social birds and are often seen in pairs or small groups. They are vocal birds and have a variety of different calls and songs, which they use to communicate with each other and to defend their territory.\n\nMale ruffed grouse are known for their distinctive drumming calls, which they use to attract mates and defend their territory. They have a variety of different drumming patterns, which they use to communicate with females and to defend their territory from other males. Female ruffed grouse are less vocal and tend to give shorter, softer calls.\n\nRuffed grouse are territorial birds and will defend their territory from other grouse and other birds. They are also known to be aggressive towards other birds at feeding stations, and will often dominate and exclude other species from feeding areas.',
        "duration": "T13S",
        "order": 573
    },
    "rufous-hummingbird": {
        "name": "Rufous hummingbird",
        "slug": "rufous-hummingbird",
        "text": "",
        "duration": "T22S",
        "order": 496
    },
    "rufous-crowned-sparrow": {
        "name": "Rufous-crowned sparrow",
        "slug": "rufous-crowned-sparrow",
        "text": "",
        "duration": "T26S",
        "order": 37
    },
    "rufous-winged-sparrow": {
        "name": "Rufous-winged sparrow",
        "slug": "rufous-winged-sparrow",
        "text": "",
        "duration": "T49S",
        "order": 6
    },
    "rusty-blackbird": {
        "name": "Rusty blackbird",
        "slug": "rusty-blackbird",
        "text": "",
        "duration": "T42S",
        "order": 296
    },
    "sabines-gull": {
        "name": "Sabine's Gull",
        "slug": "sabines-gull",
        "text": "",
        "duration": "T17S",
        "order": 182
    },
    "sage-thrasher": {
        "name": "Sage thrasher",
        "slug": "sage-thrasher",
        "text": "",
        "duration": "T50S",
        "order": 106
    },
    "sagebrush-sparrow": {
        "name": "Sagebrush sparrow",
        "slug": "sagebrush-sparrow",
        "text": "",
        "duration": "T3M22S",
        "order": 15
    },
    "saltmarsh-sparrow": {
        "name": "Saltmarsh sparrow",
        "slug": "saltmarsh-sparrow",
        "text": "",
        "duration": "T53S",
        "order": 105
    },
    "salvins-albatross": {
        "name": "Salvin's albatross",
        "slug": "salvins-albatross",
        "text": "",
        "duration": "T12S",
        "order": 5
    },
    "sanderling": {
        "name": "Sanderling",
        "slug": "sanderling",
        "text": "",
        "duration": "T4S",
        "order": 545
    },
    "sandhill-crane": {
        "name": "Sandhill crane",
        "slug": "sandhill-crane",
        "text": "A Sandhill crane is one of those birds that mesmerizes you with its graceful appearance. You might find them blessing wetlands with life or turning a simple into an art subject. In any case, Sandhill cranes are birds worth watching. They are a species of large cranes that have tall legs and curved elegant necks. Their crimson heads appear distinctive attached to their gray bodies. \n" +
            "You can find these cranes in open fields and wetlands throughout North America. Their name gives away their habitat, as they can be found in large numbers at the Platte River, on the edge of Nebraska's Sandhills on the American Great Plains. \n" +
            "These cranes are social creatures. You’ll most likely find them in big groups looking for food or filling the sky with their spectacular cries that resemble a trumpet orchestra. The wonders of Sandhill cranes don’t end here, as they are fantastic dancers as well! They often perform a vivid dance routine, in which they stretch their wings and leap into the sky.\n" +
            "These cranes are very sensational when it comes to family matters. The young ones stay with their parents for 9-10 months and they may take up to seven years to breed.",
        "duration": "T46S",
        "order": 585
    },
    "savannah-sparrow": {
        "name": "Savannah sparrow",
        "slug": "savannah-sparrow",
        "text": "",
        "duration": "T1M33S",
        "order": 353
    },
    "says-phoebe": {
        "name": "Say's phoebe",
        "slug": "says-phoebe",
        "text": "",
        "duration": "T36S",
        "order": 258
    },
    "scaled-quail": {
        "name": "Scaled quail",
        "slug": "scaled-quail",
        "text": "",
        "duration": "T2M16S",
        "order": 244
    },
    "scarlet-tanager": {
        "name": "Scarlet tanager",
        "slug": "scarlet-tanager",
        "text": "",
        "duration": "T1M24S",
        "order": 470
    },
    "scissor-tailed-flycatcher": {
        "name": "Scissor-tailed flycatcher",
        "slug": "scissor-tailed-flycatcher",
        "text": "",
        "duration": "T1M52S",
        "order": 442
    },
    "scotts-oriole": {
        "name": "Scott's oriole",
        "slug": "scotts-oriole",
        "text": "",
        "duration": "T16S",
        "order": 61
    },
    "seaside-sparrow": {
        "name": "Seaside sparrow",
        "slug": "seaside-sparrow",
        "text": "",
        "duration": "T2M23S",
        "order": 86
    },
    "sedge-wren": {
        "name": "Sedge wren",
        "slug": "sedge-wren",
        "text": "",
        "duration": "T2M41S",
        "order": 116
    },
    "semipalmated-plover": {
        "name": "Semipalmated plover",
        "slug": "semipalmated-plover",
        "text": "",
        "duration": "T16S",
        "order": 269
    },
    "semipalmated-sandpiper": {
        "name": "Semipalmated sandpiper",
        "slug": "semipalmated-sandpiper",
        "text": "",
        "duration": "T21S",
        "order": 295
    },
    "sharp-shinned-hawk": {
        "name": "Sharp-shinned hawk",
        "slug": "sharp-shinned-hawk",
        "text": 'The sharp-shinned hawk (Accipiter striatus) is a small, agile bird of prey with a distinctive appearance and behavior. It is found in a wide range of habitats across much of the United States and Canada, and is known for its stealthy hunting style, its small size, and its sharp, hooked bill. In this article, we will explore the fascinating world of the sharp-shinned hawk, including its physical characteristics, habitat, diet, behavior, and conservation status.\n\nPhysical Characteristics of Sharp-shinned Hawks\n\nSharp-shinned hawks are small birds, with a length of about 9 to 13 inches and a wingspan of about 18 to 22 inches. They have a distinctive appearance, with a small, rounded head, a small, sharp bill, and a long, narrow tail. They have a sleek, streamlined body, with short, rounded wings and a long, narrow tail.\n\nMale and female sharp-shinned hawks are similar in appearance, but males are slightly smaller. Juvenile sharp-shinned hawks are similar in appearance to adults, but have a more mottled, speckled plumage.\n\nSharp-shinned hawks are known for their distinctive calls, which include a series of high-pitched, whistling "keewik" calls. They also have a variety of softer, more subdued calls, which they use to communicate with each other.\n\nHabitat and Distribution of Sharp-shinned Hawks\n\nSharp-shinned hawks are found in a wide range of habitats across much of the United States and Canada, including forests, woodlands, and suburban areas. They are found in a variety of habitats, including deciduous forests, coniferous forests, and mixed forests. They are also found in gardens, parks, and other green spaces.\n\nIn their natural habitat, sharp-shinned hawks are found in wooded areas, where they can find food and shelter in the form of small mammals, birds, reptiles, and insects. They are adapted to living in forested environments and are able to thrive in the dense canopy of these habitats. In urban areas, they are often found in gardens, parks, and other green spaces, where they can find food and shelter.\n\nDiet and Feeding Behavior of Sharp-shinned Hawks\n\nSharp-shinned hawks are carnivorous, meaning they eat animals. Their diet consists of small mammals, birds, reptiles, and insects. They are opportunistic feeders and will eat whatever prey is available to them.\n\nSharp-shinned hawks are stealthy predators and are known for their agile, acrobatic flight. They are often seen flying low over fields, forests, and other wooded areas, using their keen eyesight and quick reflexes to catch prey. They are also known to hunt from perches, where they wait patiently for prey to come within range.\n\nBehavior and Communication of Sharp-shinned Hawks\n\nSharp-shinned hawks are social birds and are often seen in pairs or small groups. They are vocal birds and have a variety of different calls and songs, which they use to communicate with each other and to defend their territory.\n\nMale sharp-shinned hawks are known for their distinctive songs, which they use to attract mates and defend their territory.',
        "duration": "T2M6S",
        "order": 566
    },
    "sharp-tailed-grouse": {
        "name": "Sharp-tailed grouse",
        "slug": "sharp-tailed-grouse",
        "text": "",
        "duration": "T31S",
        "order": 482
    },
    "short-billed-dowitcher": {
        "name": "Short-billed dowitcher",
        "slug": "short-billed-dowitcher",
        "text": "",
        "duration": "T18S",
        "order": 139
    },
    "short-eared-owl": {
        "name": "Short-eared owl",
        "slug": "short-eared-owl",
        "text": "",
        "duration": "T1M29S",
        "order": 502
    },
    "smiths-longspur": {
        "name": "Smith's longspur",
        "slug": "smiths-longspur",
        "text": "",
        "duration": "T2M19S",
        "order": 24
    },
    "smooth-billed-ani": {
        "name": "Smooth-billed ani",
        "slug": "smooth-billed-ani",
        "text": "",
        "duration": "T13S",
        "order": 115
    },
    "snail-kite": {
        "name": "Snail kite",
        "slug": "snail-kite",
        "text": "",
        "duration": "T22S",
        "order": 277
    },
    "snow-bunting": {
        "name": "Snow bunting",
        "slug": "snow-bunting",
        "text": "",
        "duration": "T1M9S",
        "order": 476
    },
    "snow-goose": {
        "name": "Snow goose",
        "slug": "snow-goose",
        "text": 'The snow goose (Anser caerulescens) is a large, striking bird with a distinctive white plumage and black wingtips. It is a migratory species that breeds in the Arctic tundra and winters in more temperate regions of North America. In this article, we will explore the fascinating world of the snow goose, including its physical characteristics, habitat, diet, behavior, and conservation status.\n\nPhysical Characteristics of Snow Geese\n\nSnow goose are large birds, with a length of about 27 to 30 inches and a wingspan of about 45 to 50 inches. They have a distinctive appearance, with a long, slender neck, a small head, and a long, pointed bill. They have a predominantly white plumage, with black wingtips and a black patch on their heads.\n\nMale and female snow geese are similar in appearance, but males are slightly larger and have a more pointed bill. Juvenile snow geese are similar in appearance to adults, but have a brown, rather than a black, patch on their heads.\n\nSnow goose are known for their distinctive calls, which include a series of loud, honking "honk-honk" calls. They also have a variety of softer, more subdued calls, which they use to communicate with each other.\n\nHabitat and Distribution of Snow Geese\n\nSnow goose are migratory birds that breed in the Arctic tundra of Canada and Alaska. They winter in more temperate regions of North America, including the southern United States, Mexico, and Central America. During the breeding season, they are found in grassy tundra habitats, where they build their nests on the ground. During the winter, they are found in a variety of habitats, including wetlands, grasslands, and agricultural areas.\n\nSnow goose are adapted to living in cold, wet environments and are able to thrive in the harsh conditions of the Arctic tundra. They are also adaptable birds and are able to survive in a wide range of habitats, including wetlands, grasslands, and agricultural areas.\n\nDiet and Feeding Behavior of Snow Geese\n\nSnow goose are herbivorous, meaning they eat plants. Their diet consists of grasses, sedges, and other aquatic plants, as well as grains and seeds. They are opportunistic feeders and will eat whatever food is available to them.\n\nSnow goose are gregarious birds and are often seen in large flocks. They are known to feed in shallow water or on land, where they use their long, pointed bills to forage for food. They are also known to feed on grains and seeds in agricultural fields, where they can cause damage to crops.\n\nBehavior and Communication of Snow Geese\n\nSnow goose are social birds and are often seen in large flocks. They are vocal birds and have a variety of different calls and songs, which they use to communicate with each other and to defend their territory.\n\nMale snow geese are known for their distinctive songs, which they use to attract mates and defend their territory. They have a variety of different songs, including a series of loud, honking "honk-honk" calls. Female snow geese are less vocal and tend to give shorter, softer calls.\n\nSnow geese are territorial birds and will defend their territory from other geese and other birds. They are also known to be aggressive towards other birds at feeding stations, and will often dominate and exclude other species from feeding areas.\n\nConservation Status\n\nThe snow goose is classified as a species of "Least Concern" by the International Union for Conservation of Nature (IUCN).',
        "duration": "T30S",
        "order": 576
    },
    "snowy-egret": {
        "name": "Snowy egret",
        "slug": "snowy-egret",
        "text": "",
        "duration": "T6S",
        "order": 498
    },
    "snowy-owl": {
        "name": "Snowy owl",
        "slug": "snowy-owl",
        "text": "You may call them Hedwig from the Harry Potter franchise, but not all Snowy owls are Hedwig. These owls are one of the most magnificent and charming creatures in the world. As their name suggests, Snowy owls have an almost entirely snowy white body with brown markings appearing randomly on their body.\n" +
            "Their most remarkable feature is their piercing bright yellow eyes. You may find snowy owls anywhere from shorelines of oceans and lakes to airport lands and agricultural fields camouflaging in the spirit of winter. Snowy owls are not a big fan of heights. You’ll find them mostly close to the ground while flying. They also usually perch on short structures such as telephone poles and fence posts.\n" +
            "Snowy owls are about the size of a crow with 20.5-27.9 in (52-71 cm) in length and 56.4-104.1 oz (1600-2950 g) weight. These owls live for 10 years and start looking for a mate when they finish their second birthday.\n" +
            "Snowy owls consider a variety of food sources as their diet. Their diet mostly includes lemmings and small mammals and birds. You can find these birds anywhere in the North merging with the snow.",
        "duration": "T31S",
        "order": 591
    },
    "snowy-plover": {
        "name": "Snowy plover",
        "slug": "snowy-plover",
        "text": "",
        "duration": "T13S",
        "order": 431
    },
    "solitary-sandpiper": {
        "name": "Solitary sandpiper",
        "slug": "solitary-sandpiper",
        "text": "",
        "duration": "T10S",
        "order": 181
    },
    "song-sparrow": {
        "name": "Song sparrow",
        "slug": "song-sparrow",
        "text": "",
        "duration": "T35S",
        "order": 529
    },
    "sooty-grouse": {
        "name": "Sooty grouse",
        "slug": "sooty-grouse",
        "text": "",
        "duration": "T52S",
        "order": 276
    },
    "sooty-tern": {
        "name": "Sooty Tern",
        "slug": "sooty-tern",
        "text": "",
        "duration": "T45S",
        "order": 257
    },
    "sora": {
        "name": "Sora",
        "slug": "sora",
        "text": "Walking through the marshes of North America, you might see a bright yellow bill poking out of the water. It might even remind you of candy corn. In that case, you may be encountering a Sora. This small discreet bird has a brown-and-gray body and unlike his peers, prefers walking to flying.\n" +
            "His daily routine is marching through wetlands while rapidly flicking its white tail. He looks for seeds, nurtures himself, and resides in a nest floating on shallow wetlands. If you want to catch a Sora in action, early in the morning or late in the evening is the best time to do so as they wander out of hiding to look for food. Given their chubby appearance, you may not count them as great flying birds, but they can fly hundreds of miles to reach Central and South America during migration season.\n" +
            "They usually spend April until July breeding and expanding their families. They’ve been very successful too and they’re considered the most widespread rail in North America. Predatory birds and some hungry mammals are considered Sora's natural enemies.\n" +
            "If you ever heard the names meadow chicken, Carolina rail, ortolan, and soree, they’re referring to Sora.",
        "duration": "T1M12S",
        "order": 599
    },
    "spectacled-eider": {
        "name": "Spectacled eider",
        "slug": "spectacled-eider",
        "text": "",
        "duration": "T48S",
        "order": 131
    },
    "spotted-owl": {
        "name": "Spotted owl",
        "slug": "spotted-owl",
        "text": "",
        "duration": "T1M36S",
        "order": 515
    },
    "spotted-sandpiper": {
        "name": "Spotted sandpiper",
        "slug": "spotted-sandpiper",
        "text": "",
        "duration": "T49S",
        "order": 317
    },
    "spotted-towhee": {
        "name": "Spotted towhee",
        "slug": "spotted-towhee",
        "text": "",
        "duration": "T1M38S",
        "order": 377
    },
    "spragues-pipit": {
        "name": "Sprague's pipit",
        "slug": "spragues-pipit",
        "text": "",
        "duration": "T29S",
        "order": 55
    },
    "spruce-grouse": {
        "name": "Spruce grouse",
        "slug": "spruce-grouse",
        "text": "",
        "duration": "T11S",
        "order": 501
    },
    "stellers-eider": {
        "name": "Steller's eider",
        "slug": "stellers-eider",
        "text": "",
        "duration": "T2M25S",
        "order": 114
    },
    "stellers-jay": {
        "name": "Steller's jay",
        "slug": "stellers-jay",
        "text": 'Steller\'s jay (Cyanocitta stelleri) is a medium-sized, brightly colored bird with a distinctive appearance and behavior. It is found in the coniferous forests of western North America, and is known for its striking blue and black plumage, its bold and inquisitive nature, and its loud, harsh calls. In this article, we will explore the fascinating world of Steller\'s jay, including its physical characteristics, habitat, diet, behavior, and conservation status.\n\nPhysical Characteristics of Steller\'s Jays\n\nSteller\'s jays are medium-sized birds, with a length of about 12 to 14 inches and a wingspan of about 16 to 20 inches. They have a distinctive appearance, with a large, crestless head, a strong, conical bill, and a long, rounded tail. They have a blue and black plumage, with a bright blue head, neck, and breast, and a black back, wings, and tail.\n\nMale and female Steller\'s jays are similar in appearance, but males are slightly larger. Juvenile Steller\'s jays are similar in appearance to adults, but have a brown, rather than a blue, head and neck.\n\nSteller\'s jays are known for their distinctive calls, which include a series of loud, harsh "jay" calls. They also have a variety of softer, more subdued calls, which they use to communicate with each other.\n\nHabitat and Distribution of Steller\'s Jays\n\nSteller\'s jays are found in the coniferous forests of western North America, including the Rocky Mountains, the Pacific Northwest, and the Sierra Nevada. They are found in a variety of habitats, including coniferous forests, mixed forests, and gardens. They are also found in urban areas, where they are attracted to bird feeders and gardens.\n\nIn their natural habitat, Steller\'s jays are found in coniferous forests, where they can find food and shelter in the form of seeds, berries, insects, and other small animals. They are adaptable birds and are able to thrive in a wide range of environments. In urban areas, they are often found in gardens, parks, and other green spaces, where they can find food and shelter.\n\nDiet and Feeding Behavior of Steller\'s Jays\n\nSteller\'s jays are omnivorous, meaning they eat both plants and animals. Their diet consists of seeds, berries, insects, and other small animals. They are opportunistic feeders and will eat whatever food is available to them.\n\nSteller\'s jays are gregarious birds and are often seen in small flocks. They are known to forage for food on the ground, in trees, and at bird feeders. They are also known to cache, or store, food for later use.\n\nBehavior and Communication of Steller\'s Jays\n\nSteller\'s jays are social birds and are often seen in pairs or small groups. They are vocal birds and have a variety of different calls and songs, which they use to communicate with each other and to defend their territory.\n\nMale Steller\'s jays are known for their distinctive songs, which they use to attract mates and defend their territory. They have a variety of different songs, including a series of loud, harsh "jay" calls. Female Steller\'s jays are less vocal and tend to give shorter, softer calls.\n\nSteller\'s jays are territorial birds and will defend their territory from other jays and other birds.',
        "duration": "T16S",
        "order": 570
    },
    "stilt-sandpiper": {
        "name": "Stilt sandpiper",
        "slug": "stilt-sandpiper",
        "text": "",
        "duration": "T35S",
        "order": 155
    },
    "summer-tanager": {
        "name": "Summer tanager",
        "slug": "summer-tanager",
        "text": "",
        "duration": "T3M28S",
        "order": 404
    },
    "surf-scoter": {
        "name": "Surf scoter",
        "slug": "surf-scoter",
        "text": "",
        "duration": "T29S",
        "order": 372
    },
    "surfbird": {
        "name": "Surfbird",
        "slug": "surfbird",
        "text": "",
        "duration": "T14S",
        "order": 111
    },
    "swainsons-hawk": {
        "name": "Swainson's hawk",
        "slug": "swainsons-hawk",
        "text": "",
        "duration": "T1M14S",
        "order": 461
    },
    "swainsons-thrush": {
        "name": "Swainson's thrush",
        "slug": "swainsons-thrush",
        "text": "",
        "duration": "T1M40S",
        "order": 366
    },
    "swainsons-warbler": {
        "name": "Swainson's warbler",
        "slug": "swainsons-warbler",
        "text": "",
        "duration": "T1M13S",
        "order": 70
    },
    "swallow-tailed-kite": {
        "name": "Swallow-tailed kite",
        "slug": "swallow-tailed-kite",
        "text": "",
        "duration": "T15S",
        "order": 394
    },
    "swamp-sparrow": {
        "name": "Swamp sparrow",
        "slug": "swamp-sparrow",
        "text": "",
        "duration": "T30S",
        "order": 306
    },
    "tennessee-warbler": {
        "name": "Tennessee warbler",
        "slug": "tennessee-warbler",
        "text": "",
        "duration": "T22S",
        "order": 385
    },
    "thick-billed-murre": {
        "name": "Thick-billed murre",
        "slug": "thick-billed-murre",
        "text": "",
        "duration": "T1M9S",
        "order": 169
    },
    "townsends-solitaire": {
        "name": "Townsend's solitaire",
        "slug": "townsends-solitaire",
        "text": "",
        "duration": "T5M45S",
        "order": 168
    },
    "townsends-warbler": {
        "name": "Townsend's warbler",
        "slug": "townsends-warbler",
        "text": "",
        "duration": "T59S",
        "order": 294
    },
    "tree-swallow": {
        "name": "Tree swallow",
        "slug": "tree-swallow",
        "text": "",
        "duration": "T1M38S",
        "order": 410
    },
    "tricolored-blackbird": {
        "name": "Tricolored blackbird",
        "slug": "tricolored-blackbird",
        "text": "",
        "duration": "T45S",
        "order": 92
    },
    "tricolored-heron": {
        "name": "Tricolored heron",
        "slug": "tricolored-heron",
        "text": "",
        "duration": "T6S",
        "order": 400
    },
    "tropical-kingbird": {
        "name": "Tropical kingbird",
        "slug": "tropical-kingbird",
        "text": "",
        "duration": "T22S",
        "order": 180
    },
    "trumpeter-swan": {
        "name": "Trumpeter swan",
        "slug": "trumpeter-swan",
        "text": "",
        "duration": "T1M13S",
        "order": 541
    },
    "tufted-titmouse": {
        "name": "Tufted titmouse",
        "slug": "tufted-titmouse",
        "text": "",
        "duration": "T1M8S",
        "order": 554
    },
    "tundra-bean-goose": {
        "name": "Tundra bean goose",
        "slug": "tundra-bean-goose",
        "text": "",
        "duration": "T20S",
        "order": 91
    },
    "tundra-swan": {
        "name": "Tundra swan",
        "slug": "tundra-swan",
        "text": "",
        "duration": "T41S",
        "order": 477
    },
    "upland-sandpiper": {
        "name": "Upland sandpiper",
        "slug": "upland-sandpiper",
        "text": "",
        "duration": "T47S",
        "order": 138
    },
    "varied-thrush": {
        "name": "Varied thrush",
        "slug": "varied-thrush",
        "text": "",
        "duration": "T52S",
        "order": 389
    },
    "vauxs-swift": {
        "name": "Vaux's swift",
        "slug": "vauxs-swift",
        "text": "",
        "duration": "T49S",
        "order": 224
    },
    "veery": {
        "name": "Veery",
        "slug": "veery",
        "text": "",
        "duration": "T38S",
        "order": 350
    },
    "verdin": {
        "name": "Verdin",
        "slug": "verdin",
        "text": "",
        "duration": "T1M25S",
        "order": 507
    },
    "vermilion-flycatcher": {
        "name": "Vermilion flycatcher",
        "slug": "vermilion-flycatcher",
        "text": "",
        "duration": "T33S",
        "order": 359
    },
    "vesper-sparrow": {
        "name": "Vesper sparrow",
        "slug": "vesper-sparrow",
        "text": "",
        "duration": "T5M5S",
        "order": 230
    },
    "violet-crowned-hummingbird": {
        "name": "Violet-crowned hummingbird",
        "slug": "violet-crowned-hummingbird",
        "text": "",
        "duration": "T32S",
        "order": 38
    },
    "violet-green-swallow": {
        "name": "Violet-green swallow",
        "slug": "violet-green-swallow",
        "text": "",
        "duration": "T15S",
        "order": 130
    },
    "virginia-rail": {
        "name": "Virginia rail",
        "slug": "virginia-rail",
        "text": "",
        "duration": "T1M41S",
        "order": 396
    },
    "virginias-warbler": {
        "name": "Virginia's warbler",
        "slug": "virginias-warbler",
        "text": "",
        "duration": "T53S",
        "order": 69
    },
    "wandering-tattler": {
        "name": "Wandering tattler",
        "slug": "wandering-tattler",
        "text": "",
        "duration": "T17S",
        "order": 80
    },
    "warbling-vireo": {
        "name": "Warbling vireo",
        "slug": "warbling-vireo",
        "text": "",
        "duration": "T1M6S",
        "order": 243
    },
    "wedge-tailed-shearwater": {
        "name": "Wedge-tailed shearwater",
        "slug": "wedge-tailed-shearwater",
        "text": "",
        "duration": "T9S",
        "order": 129
    },
    "western-bluebird": {
        "name": "Western bluebird",
        "slug": "western-bluebird",
        "text": "",
        "duration": "T48S",
        "order": 376
    },
    "western-grebe": {
        "name": "Western grebe",
        "slug": "western-grebe",
        "text": "",
        "duration": "T1M25S",
        "order": 325
    },
    "western-gull": {
        "name": "Western gull",
        "slug": "western-gull",
        "text": "",
        "duration": "T44S",
        "order": 205
    },
    "western-kingbird": {
        "name": "Western kingbird",
        "slug": "western-kingbird",
        "text": "",
        "duration": "T41S",
        "order": 275
    },
    "western-meadowlark": {
        "name": "Western meadowlark",
        "slug": "western-meadowlark",
        "text": "",
        "duration": "T58S",
        "order": 436
    },
    "western-sandpiper": {
        "name": "Western sandpiper",
        "slug": "western-sandpiper",
        "text": "",
        "duration": "T29S",
        "order": 274
    },
    "western-screech-owl": {
        "name": "Western screech owl",
        "slug": "western-screech-owl",
        "text": "",
        "duration": "T46S",
        "order": 423
    },
    "western-tanager": {
        "name": "Western tanager",
        "slug": "western-tanager",
        "text": "",
        "duration": "T37S",
        "order": 384
    },
    "western-wood-pewee": {
        "name": "Western wood pewee",
        "slug": "western-wood-pewee",
        "text": "",
        "duration": "T1M2S",
        "order": 128
    },
    "whimbrel": {
        "name": "Whimbrel",
        "slug": "whimbrel",
        "text": "",
        "duration": "T3M26S",
        "order": 450
    },
    "whiskered-screech-owl": {
        "name": "Whiskered screech owl",
        "slug": "whiskered-screech-owl",
        "text": "",
        "duration": "T37S",
        "order": 103
    },
    "white-breasted-nuthatch": {
        "name": "White-breasted nuthatch",
        "slug": "white-breasted-nuthatch",
        "text": "",
        "duration": "T11S",
        "order": 497
    },
    "white-cheeked-pintail": {
        "name": "White-cheeked pintail",
        "slug": "white-cheeked-pintail",
        "text": "",
        "duration": "T20S",
        "order": 85
    },
    "white-crowned-sparrow": {
        "name": "White-crowned sparrow",
        "slug": "white-crowned-sparrow",
        "text": "",
        "duration": "T3M47S",
        "order": 459
    },
    "white-eyed-vireo": {
        "name": "White-eyed vireo",
        "slug": "white-eyed-vireo",
        "text": "",
        "duration": "T37S",
        "order": 229
    },
    "white-faced-ibis": {
        "name": "White-faced ibis",
        "slug": "white-faced-ibis",
        "text": "",
        "duration": "T31S",
        "order": 191
    },
    "white-headed-woodpecker": {
        "name": "White-headed woodpecker",
        "slug": "white-headed-woodpecker",
        "text": "",
        "duration": "T48S",
        "order": 127
    },
    "white-rumped-sandpiper": {
        "name": "White-rumped sandpiper",
        "slug": "white-rumped-sandpiper",
        "text": "",
        "duration": "T5S",
        "order": 104
    },
    "white-tailed-kite": {
        "name": "White-tailed kite",
        "slug": "white-tailed-kite",
        "text": "",
        "duration": "T34S",
        "order": 358
    },
    "white-tailed-tropicbird": {
        "name": "White-tailed tropicbird",
        "slug": "white-tailed-tropicbird",
        "text": "",
        "duration": "T41S",
        "order": 147
    },
    "white-throated-sparrow": {
        "name": "White-throated sparrow",
        "slug": "white-throated-sparrow",
        "text": "",
        "duration": "T5M46S",
        "order": 466
    },
    "white-throated-swift": {
        "name": "White-throated swift",
        "slug": "white-throated-swift",
        "text": "",
        "duration": "T10S",
        "order": 79
    },
    "white-winged-crossbill": {
        "name": "White-winged crossbill",
        "slug": "white-winged-crossbill",
        "text": "",
        "duration": "T19S",
        "order": 126
    },
    "white-winged-dove": {
        "name": "White-winged dove",
        "slug": "white-winged-dove",
        "text": "",
        "duration": "T1M5S",
        "order": 465
    },
    "whooping-crane": {
        "name": "Whooping crane",
        "slug": "whooping-crane",
        "text": 'The whooping crane (Grus americana) is a large, endangered bird with a distinctive appearance and behavior. It is found in a small range in the United States and Canada, and is known for its striking white plumage, its tall, slender build, and its loud, distinctive calls. In this article, we will explore the fascinating world of the whooping crane, including its physical characteristics, habitat, diet, behavior, and conservation status.\n\nPhysical Characteristics of Whooping Cranes\n\nWhooping cranes are large birds, with a length of about 5 to 5.5 feet and a wingspan of about 7 to 8 feet. They have a distinctive appearance, with a tall, slender build, a long, thin neck, and a large, round head. They have a striking white plumage, with a white head, neck, and body, and a black crown and face.\n\nMale and female whooping cranes are similar in appearance, but males are slightly larger. Juvenile whooping cranes are similar in appearance to adults, but have a more mottled, brownish plumage.\n\nWhooping cranes are known for their loud, distinctive calls, which include a series of deep, resonant "whoops" and "whoops." They also have a variety of softer, more subdued calls, which they use to communicate with each other.\n\nHabitat and Distribution of Whooping Cranes\n\nWhooping cranes are found in a small range in the United States and Canada, including parts of Texas, Oklahoma, Arkansas, and Louisiana in the United States, and parts of Alberta and Saskatchewan in Canada. They are found in a variety of habitats, including wetlands, grasslands, and wooded areas.\n\nIn their natural habitat, whooping cranes are found in wetlands and grasslands, where they can find food and shelter in the form of insects, worms, and other small prey. They are adapted to living in open, grassy environments and are able to thrive in the shallow waters of these habitats.\n\nDiet and Feeding Behavior of Whooping Cranes\n\nWhooping cranes are omnivorous, meaning they eat both plants and animals. Their diet consists of insects, worms, crustaceans, and other small prey. They are opportunistic feeders and will eat whatever food is available to them.\n\nWhooping cranes are active during the day and are often seen foraging for food in wetlands, grasslands, and other open areas. They are known to feed on a variety of insects, including beetles, ants, and grasshoppers, as well as worms and other small prey. They are also known to feed on plants, including roots, seeds, and berries.\n\nBehavior and Communication of Whooping Cranes\n\nWhooping cranes are social birds and are often seen in pairs or small groups. They are vocal birds and have a variety of different calls and songs, which they use to communicate with each other and to defend their territory.\n\nMale whooping cranes are known for their loud, distinctive calls, which they use to attract mates and defend their territory. They have a variety of different calls, including a series of deep, resonant "whoops" and "whoops." Female whooping cranes are less vocal and tend to give shorter, softer calls.\n\nWhooping cranes are territorial birds and will defend their territory from other whooping cranes and other birds.',
        "duration": "T29S",
        "order": 561
    },
    "wild-turkey": {
        "name": "Wild turkey",
        "slug": "wild-turkey",
        "text": "Though they’re often confused with their domestic counterparts, Wild turkeys in size and behavior. They are, however, ancestors of domestic turkeys.\n" +
            "Wild turkeys are one of the largest and heaviest birds in the world with an average of 43.3-45.3 in (110-115 cm) in length and 88.2-381.0 oz (2500-10800 g) in weight.\n" +
            "These birds have a unique color scheme that’s mostly dark. Although, you may see shades of red and blue on the breast and bronze on the tail.\n" +
            "Turkeys walking on the ground rather than hovering in mid-air. They brush away the leaves with their strong feet and search for insects, snails, nuts, and berries.\n" +
            "Wild turkeys prefer to stay in flocks and perform their daily routines together. Come nighttime, they finally stretch their wings to fly up the trees and slumber away their tiring food gathering day.\n" +
            "You’ll find these turkeys in North American forests. They may also be found in backyards and on the side of the roads.\n" +
            "Turkeys lay about 4 to 17 eggs and it may not be a treat to be one of those eggs. Females feed their chicks only for a few days. From there, they’re on their own.",
        "duration": "T2M56S",
        "order": 589
    },
    "willet": {
        "name": "Willet",
        "slug": "willet",
        "text": "",
        "duration": "T54S",
        "order": 467
    },
    "williamsons-sapsucker": {
        "name": "Williamson's sapsucker",
        "slug": "williamsons-sapsucker",
        "text": "",
        "duration": "T2M17S",
        "order": 110
    },
    "willow-flycatcher": {
        "name": "Willow flycatcher",
        "slug": "willow-flycatcher",
        "text": "",
        "duration": "T43S",
        "order": 179
    },
    "willow-ptarmigan": {
        "name": "Willow Ptarmigan",
        "slug": "willow-ptarmigan",
        "text": "",
        "duration": "T1M4S",
        "order": 375
    },
    "wilsons-phalarope": {
        "name": "Wilson's phalarope",
        "slug": "wilsons-phalarope",
        "text": "",
        "duration": "T2M9S",
        "order": 178
    },
    "wilsons-plover": {
        "name": "Wilson's plover",
        "slug": "wilsons-plover",
        "text": "",
        "duration": "T13S",
        "order": 113
    },
    "wilsons-snipe": {
        "name": "Wilson's snipe",
        "slug": "wilsons-snipe",
        "text": "",
        "duration": "T32S",
        "order": 336
    },
    "wilsons-warbler": {
        "name": "Wilson's warbler",
        "slug": "wilsons-warbler",
        "text": "",
        "duration": "T1M33S",
        "order": 311
    },
    "winter-wren": {
        "name": "Winter wren",
        "slug": "winter-wren",
        "text": "",
        "duration": "T1M23S",
        "order": 347
    },
    "wood-duck": {
        "name": "Wood duck",
        "slug": "wood-duck",
        "text": "Known for their exotic glossy green head, Wood ducks are unique and easily recognizable among ducks. They have a green crested head, a chestnut breast, and a broad tail. Wood ducks love anywhere moist and full of woods. So marshes, beaver ponds, small lakes, swamps, and streams are where you can find them.\n" +
            "Wood ducks not only deviate in the color pattern but also show different behavior compared to other ducks. They perch on trees and build their nests there.\n" +
            "They also have no trouble soaring in mid-air. When Wood ducks move to water, they may remind of pigeons as they rock back and forth as they swim. Immersing their neck and heads, these ducks look for food underwater.\n" +
            "Wood ducks are often seen in groups of less than 20 members. They prefer a life of seclusion from other waterfowls.\n" +
            "A Wood duck has a size between a crow and a goose having 18.5-21.3 in (47-54 cm) in length and 16.0-30.4 oz (454-862 g) as their weight.\n" +
            "If you wish to see a Wood duck in real life, you can look for them throughout southern Canada and the U.S.",
        "duration": "T1M15S",
        "order": 588
    },
    "wood-stork": {
        "name": "Wood stork",
        "slug": "wood-stork",
        "text": "",
        "duration": "T23S",
        "order": 506
    },
    "wood-thrush": {
        "name": "Wood thrush",
        "slug": "wood-thrush",
        "text": "",
        "duration": "T58S",
        "order": 441
    },
    "woodhouses-scrub-jay": {
        "name": "Woodhouse's scrub jay",
        "slug": "woodhouses-scrub-jay",
        "text": "",
        "duration": "T1M31S",
        "order": 125
    },
    "worm-eating-warbler": {
        "name": "Worm-eating warbler",
        "slug": "worm-eating-warbler",
        "text": "",
        "duration": "T24S",
        "order": 102
    },
    "wrentit": {
        "name": "Wrentit",
        "slug": "wrentit",
        "text": "",
        "duration": "T22S",
        "order": 109
    },
    "yellow-rail": {
        "name": "Yellow rail",
        "slug": "yellow-rail",
        "text": "",
        "duration": "T2M14S",
        "order": 154
    },
    "yellow-warbler": {
        "name": "Yellow warbler",
        "slug": "yellow-warbler",
        "text": "",
        "duration": "T1M36S",
        "order": 486
    },
    "yellow-bellied-flycatcher": {
        "name": "Yellow-bellied flycatcher",
        "slug": "yellow-bellied-flycatcher",
        "text": "",
        "duration": "T43S",
        "order": 242
    },
    "yellow-bellied-sapsucker": {
        "name": "Yellow-bellied sapsucker",
        "slug": "yellow-bellied-sapsucker",
        "text": "",
        "duration": "T26S",
        "order": 500
    },
    "yellow-billed-cuckoo": {
        "name": "Yellow-billed cuckoo",
        "slug": "yellow-billed-cuckoo",
        "text": "",
        "duration": "T2M24S",
        "order": 364
    },
    "yellow-billed-magpie": {
        "name": "Yellow-billed magpie",
        "slug": "yellow-billed-magpie",
        "text": "",
        "duration": "T29S",
        "order": 228
    },
    "yellow-breasted-chat": {
        "name": "Yellow-breasted chat",
        "slug": "yellow-breasted-chat",
        "text": "",
        "duration": "T1M1S",
        "order": 287
    },
    "yellow-crowned-night-heron": {
        "name": "Yellow-crowned night heron",
        "slug": "yellow-crowned-night-heron",
        "text": "",
        "duration": "T2M49S",
        "order": 388
    },
    "yellow-footed-gull": {
        "name": "Yellow-footed gull",
        "slug": "yellow-footed-gull",
        "text": "",
        "duration": "T32S",
        "order": 10
    },
    "yellow-headed-blackbird": {
        "name": "Yellow-headed blackbird",
        "slug": "yellow-headed-blackbird",
        "text": "",
        "duration": "T17S",
        "order": 241
    },
    "yellow-rumped-warbler": {
        "name": "Yellow-rumped warbler",
        "slug": "yellow-rumped-warbler",
        "text": "",
        "duration": "T42S",
        "order": 494
    },
    "yellow-throated-vireo": {
        "name": "Yellow-throated vireo",
        "slug": "yellow-throated-vireo",
        "text": "",
        "duration": "T37S",
        "order": 177
    },
    "yellow-throated-warbler": {
        "name": "Yellow-throated warbler",
        "slug": "yellow-throated-warbler",
        "text": "",
        "duration": "T1M20S",
        "order": 324
    },
    "zone-tailed-hawk": {
        "name": "Zone-tailed hawk",
        "slug": "zone-tailed-hawk",
        "text": "",
        "duration": "T36S",
        "order": 240
    }
}
